import React, { useState, useEffect, useRef } from 'react';

import { Container, Row, Col, Card, Button, Form, Dropdown, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FaChevronDown, FaQuestionCircle, FaInfoCircle } from 'react-icons/fa';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

import img1 from '../../Pages/Images/basicinfo_img1.webp';

import img2 from '../../Pages/Images/basicinfo_img2_company.webp';

import img3 from '../../Pages/Images/basicinfo_img3.webp';

import 'bootstrap-icons/font/bootstrap-icons.css';

import './BasicInfo.css';

import Swal from 'sweetalert2';

import { useLocation, useNavigate } from 'react-router-dom';

import BaseUrl from '../../ApiServices/BaseUrl';

import AgencyNavbar from '../../Pages/Navbar/AgencyNavbar';
import {
    DOMESTIC_HELPER_POSITIONS,
    EMPLOYER_CATEGORY_OPTIONS,
    HEALTHCARE_POSITIONS,
    HOSPITALITY_CATEGORY,
    HOSPITALITY_POSITIONS,
    SOFTWARE_IT_CATEGORY,
    SOFTWARE_IT_POSITIONS,
    CONSTRUCTION_CATEGORY,
    CONSTRUCTION_POSITIONS,
    RETAIL_SALES_CATEGORY,
    RETAIL_SALES_POSITIONS,
    CLEANING_MAINTENANCE_CATEGORY,
    CLEANING_MAINTENANCE_POSITIONS,
    SECURITY_CATEGORY,
    SECURITY_POSITIONS,
    OFFICE_STAFF_CATEGORY,
    OFFICE_STAFF_POSITIONS,
    DRIVER_CATEGORY,
    DRIVER_POSITIONS,
    isConstructionPosition,
    isHospitalityPosition,
    isSoftwareItPosition,
    isRetailSalesPosition,
    isCleaningMaintenancePosition
} from '../../../Constants/dropdownOptions';



const AgencyBasicInfo = () => {

    const navigate = useNavigate();

    const user = JSON.parse(localStorage.getItem('user'));

    const userId = user?.id;

    const userName = user?.first_name;

    const location = useLocation();

    const { temporaryId, isEditing, existingJobData } = location.state || {};



    console.log('Received temporary_id:', temporaryId, 'isEditing:', isEditing, 'existingJobData:', existingJobData);



    // Refs for input fields

    const domesticWorkerCategoryRef = useRef(null);

    const jobTypeRef = useRef(null);

    const candidateExperienceRef = useRef(null);

    const countryRef = useRef(null);

    const stateRef = useRef(null);

    const cityRef = useRef(null);

    const jobStartingDateRef = useRef(null);



    const [formData, setFormData] = useState({

        temporary_id: temporaryId,

        user_id: userId,

        emp_name: userName,

        domestic_worker_category: 'Domestic Helper',

        job_type: 'Full Time',

        candidate_experience: 'Fresher',

        gulf_experience_years: 0,

        total_experience_years: 0,

        candidates_country_experience: ["Any Country"],

        working_city: '',

        state_or_province: '',

        country: '',

        job_starting_date: '',

        customCountryInput: '',

        posted_by: 'Agency',

    });



    const [selectedJobType, setSelectedJobType] = useState('Full Time');

    const [selectedExperience, setSelectedExperience] = useState('Fresher');

    const [selectedCountries, setSelectedCountries] = useState(["Any Country"]);

    const [gulfExperience, setGulfExperience] = useState(0);

    const [totalExperience, setTotalExperience] = useState(0);

    const [jobStartingTimeline, setJobStartingTimeline] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const [isSaved, setIsSaved] = useState(false);

    const [selectedDate, setSelectedDate] = useState(null);

    const [selectedCategory, setSelectedCategory] = useState('Domestic Helper');



    // New state for part-time agreement

    const [showPartTimeModal, setShowPartTimeModal] = useState(false);

    const [partTimeAgreed, setPartTimeAgreed] = useState(false);

    const [pendingJobType, setPendingJobType] = useState(null);

    const [showInfoTooltip, setShowInfoTooltip] = useState(false);



    // Country lists for experience

    const experiencedCountries = [

        "Dubai", "Saudi", "Qatar", "Bahrain", "Kuwait", "Oman", "Singapore",

        "Malaysia", "Hong Kong", "Taiwan", "Lebanon", "South Korea", "Japan",

        "Macau", "Poland", "Italy"

    ];



    const fresherCountries = [

        "Any Country",

        "Bangladesh", "Burundi", "Cambodia", "Cameroon", "Ethiopia",

        "Ghana", "India", "Indonesia", "Kenya", "Myanmar",

        "Nepal", "Nigeria", "Pakistan", "Philippines", "Rwanda",

        "Sierra Leone", "Sri Lanka", "Tanzania", "Thailand", "Uganda",

        "Vietnam"

    ];



    const hospitalJobPositions = Array.from(new Set([
        ...HEALTHCARE_POSITIONS,
        "Healthcare Assistants",
        "Resident Doctor",
        "Doctors",
        "Lab Technicians",
        "Physiotherapists",
        "Elderly Care Workers",
        "Medical Technician"
    ]));



    const cncPositions = [
          "CNC Machinist",
  "CNC Programmer",
  "CNC Operator",
        "CNC Milling Programmer",
        "CNC Turning Programmer",
        "CNC 5-Axis Programmer",
        "CNC CAD/CAM Programmer",
        "CNC Setter",
        "CNC Setup Operator",
        "CNC Quality Inspector (CMM)",
        "CNC Maintenance Technician",
        "CNC Tool Room Technician",
        "CNC Production Technician",
        "CNC Machine Operator",
        "CNC Milling Operator",
        "CNC Turning Operator",
        "CNC Lathe Operator",
        "CNC VMC Operator",
        "CNC HMC Operator"
    ];
    const hospitalityJobPositions = [...HOSPITALITY_POSITIONS];
    const softwareItJobPositions = [...SOFTWARE_IT_POSITIONS];
    const constructionJobPositions = [...CONSTRUCTION_POSITIONS];
    const retailSalesJobPositions = [...RETAIL_SALES_POSITIONS];
    const cleaningMaintenanceJobPositions = [...CLEANING_MAINTENANCE_POSITIONS];
    const companyWorkerPositions = Array.from(new Set([

        ...cncPositions,
        "Workers", "General Worker", "Laborer", "Skilled Workers",
        "Construction Workers", "Skilled Construction Workers", "Construction Worker",
        "Mason", "Carpenter", "Steel Fixer", "Painter", "Scaffolder", "Plumber",
        "AC Technician", "HVAC Technician", "Chiller Technician",
        "Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator",
        "Heavy Equipment Operator", "Operator",

        "Factory Workers", "Production Workers", "Production Worker", "Warehouse Workers",

        "Warehouse Worker", "Packing Staff", "Picker & Packer",

        "Machine Operators", "Machine Operator", "Assembly Line Workers", "Assembly Line Worker",

        "Forklift Operators", "Forklift Operator",

        "Logistics Staff", "Logistics Assistant",

        "Farm Workers", "Farmar", "Fruit Pickers", "Dairy Workers", "Poultry Workers", "Greenhouse Workers",

        "Caretakers",

        "MIG Welder", "TIG Welder", "Industrial Welder", "Fabricator", "Pipe Fitter",

        "Steel Structure Welder", "6G Welder", "Structural Welder", "Welder",

        "Heavy Truck Mechanic", "Diesel Mechanic", "Auto Mechanic", "Bus Mechanic",

        "Vehicle Technician", "Heavy Equipment Mechanic", "Mechanic", "Mechanical Maintenance Technician",

        "Industrial Electrician", "Maintenance Electrician", "Panel Electrician", "Maintenance Technician",

        "Electrical Technician", "PLC Technician", "Automation Technician", "Electrician", "Instrument Technician",

        "Company Driver", "Light Driver", "Heavy Driver", "Delivery Drivers", "Truck Drivers", "Delivery Van Driver",

        "Heavy Truck Driver (CE)", "Trailer Driver", "Heavy Trailer Driver", "Fuel Tanker Driver",

        "Ready-Mix Driver", "Driver", "Driver (Company / House)", "Taxi Driver", "Bus Driver", "Motorbike Driver", "Chauffeur",

        "Bike Driver",
        "JCB Operator", "Bulldozer Operator", "Excavator Operator", "Loader Operator", "Skid Steer Loader Operator",
        "Grader Operator", "Trench Excavator / Trencher Operator", "Backhoe Operator", "Dragline Operator", "Scraper Operator",
        "Crane Operator", "Telehandler Operator", "Reach Stacker Operator", "Boom Lift / Cherry Picker Operator",
        "Container Handler Operator", "Road Roller Operator", "Asphalt Paver Operator", "Bitumen Sprayer Operator",
        "Concrete Paver Operator", "Soil Stabilizer Operator", "Drilling Machine / Drill Rig Operator",
        "Rock Breaker / Hydraulic Hammer Operator", "Loader-Dumper Operator", "Dump Truck Operator",
        "Stone Crusher Operator", "Grizzly Feeder / Conveyor Operator", "Tractor Operator", "Harvester / Combine Operator",
        "Dozer / Land Leveling Operator", "Tower Crane Operator", "Mobile Crane Operator", "Crawler Crane Operator",
        "Piling Machine Operator", "Concrete Mixer Truck Operator", "Concrete Pump Operator", "Compactor Operator",
        "Pipe Layer Operator", "Forklift / Warehouse Equipment Operator", "Boom Truck / Loader Crane Operator",
        "Road Sweeper Operator", "Water Tanker / Firefighting Vehicle Operator", "Excavator Mounted Drill Operator",
        "Heavy Truck / Tip Truck Operator", "Loader Excavator Operator", "Teleporter Crane Operator",
        "Material Handler / Port Crane Operator", "Hydraulic Excavator Operator", "Multi-Functional Heavy M",
        "Salesman",
        "Sales Executive",
        "Senior Sales Executive",
        "Outdoor Salesman",
        "Indoor Salesman",
        "Business Development Executive",
        "Marketing Executive",
        "Digital Marketing Executive",
        "Tele-Sales Executive",
        "Account Manager (Sales)",
        "Receptionist",
        "Front Desk Executive",
        "Office Assistant",
        "Office Boy",
        "Office Helper",
        "Admin Assistant",
        "Customer Support Executive",
        "Call Center Agent",
        "Admin Executive",
        "Office Administrator",
        "Operations Executive",
        "Document Controller",
        "Data Entry Operator",
        "HR Assistant",
        "HR Executive",
        "Accountant",
        "Assistant Accountant",
        "Accounts Executive",
        "Cashier",
        "Billing Executive",
        "Payroll Executive",
        "Back Office Executive",
        "Office Coordinator",
        "Project Coordinator",
        "Logistics Coordinator",
        "Sales Coordinator",
        "Office Manager",
        "Operations Manager",
        "Admin Manager",
        "Sales Manager"
    ]));


    // Job positions for Domestic Helper category - matching registration page sequence

    const jobPositions = DOMESTIC_HELPER_POSITIONS;



    // Helper function to get filtered positions based on category

    const getFilteredJobPositions = () => {

        if (selectedCategory === "Hospital") {

            return hospitalJobPositions;

        } else if (selectedCategory === HOSPITALITY_CATEGORY) {

            return hospitalityJobPositions;

        } else if (selectedCategory === SOFTWARE_IT_CATEGORY) {

            return softwareItJobPositions;

        } else if (selectedCategory === CONSTRUCTION_CATEGORY) {

            return constructionJobPositions;

        } else if (selectedCategory === RETAIL_SALES_CATEGORY) {

            return retailSalesJobPositions;

        } else if (selectedCategory === CLEANING_MAINTENANCE_CATEGORY) {

            return cleaningMaintenanceJobPositions;

        } else if (selectedCategory === SECURITY_CATEGORY) {

            return SECURITY_POSITIONS;

        } else if (selectedCategory === OFFICE_STAFF_CATEGORY) {

            return OFFICE_STAFF_POSITIONS;

        } else if (selectedCategory === DRIVER_CATEGORY || selectedCategory === "Driver") {

            return DRIVER_POSITIONS;

        } else if (selectedCategory === "Company Worker") {

            return companyWorkerPositions;

        }

        return jobPositions;

    };



    // Country-state-city data structure (matching second code)

    const countryStateCityData = {

        "United Kingdom": {

            "London": ["London", "Westminster", "Croydon", "Wembley", "Stratford", "Hounslow"],

            "Birmingham": ["Birmingham", "Solihull", "Wolverhampton", "West Bromwich", "Dudley", "Walsall"],

            "Manchester": ["Manchester", "Salford", "Bolton", "Stockport", "Oldham", "Rochdale"],

            "Leeds": ["Leeds", "Bradford", "Wakefield", "Huddersfield", "Halifax", "Dewsbury"],

            "Liverpool": ["Liverpool", "Birkenhead", "St Helens", "Bootle", "Southport", "Wallasey"]

        },



        "Croatia": {

            "City of Zagreb": ["Zagreb", "Sesvete", "Novi Zagreb"],

            "Zagreb County": ["Velika Gorica", "Samobor", "Zaprešic", "Dugo Selo"],

            "Split-Dalmatia County": ["Split", "Sinj", "Solin", "Kaštela", "Trogir", "Makarska"],

            "Istria County": ["Pula", "Porec", "Rovinj", "Umag", "Labin", "Buzet"],

            "Primorje-Gorski Kotar County": ["Rijeka", "Opatija", "Crikvenica", "Kraljevica", "Delnice"],

            "Osijek-Baranja County": ["Osijek", "Belišce", "Donji Miholjac", "Beli Manastir"],

            "Varaždin County": ["Varaždin", "Ivanec", "Ludbreg", "Lepoglava"],

            "Medimurje County": ["Cakovec", "Prelog", "Mursko Središce"],

            "Šibenik-Knin County": ["Šibenik", "Knin", "Drniš", "Vodice"],

            "Zadar County": ["Zadar", "Biograd na Moru", "Benkovac", "Nin"],

            "Bjelovar-Bilogora County": ["Bjelovar", "Cazma", "Garešnica", "Grubišno Polje"],

            "Brod-Posavina County": ["Slavonski Brod", "Nova Gradiška", "Vrpolje"],

            "Dubrovnik-Neretva County": ["Dubrovnik", "Metkovic", "Ploce", "Korcula", "Opuzen"],

            "Karlovac County": ["Karlovac", "Ogulin", "Duga Resa", "Slunj"],

            "Koprivnica-Križevci County": ["Koprivnica", "Križevci", "Ðurdevac"],

            "Krapina-Zagorje County": ["Krapina", "Zabok", "Pregrada", "Donja Stubica"],

            "Lika-Senj County": ["Gospic", "Otocac", "Senj", "Novalja"],

            "Požega-Slavonia County": ["Požega", "Pleternica", "Kutjevo"],

            "Sisak-Moslavina County": ["Sisak", "Petrinja", "Kutina", "Glina"],

            "Virovitica-Podravina County": ["Virovitica", "Orahovica", "Slatina"],

            "Vukovar-Srijem County": ["Vukovar", "Vinkovci", "Županja", "Ilok"]

        },

        "Turkey": {

            "Adana": ["Adana", "Ceyhan", "Kozan", "Feke", "Saimbeyli"],

            "Adiyaman": ["Adiyaman", "Kahta", "Besni", "Gölbasi", "Çelikhan"],

            "Afyonkarahisar": ["Afyonkarahisar", "Sandikli", "Dinar", "Bolvadin", "Sinanpasa"],

            "Agri": ["Agri", "Patnos", "Dogubayazit", "Diyadin", "Tutak"],

            "Amasya": ["Amasya", "Merzifon", "Suluova", "Tasova", "Göynücek"],

            "Ankara": ["Ankara", "Polatli", "Çubuk", "Beypazari", "Kizilcahamam"],

            "Antalya": ["Antalya", "Alanya", "Manavgat", "Serik", "Kas"],

            "Artvin": ["Artvin", "Hopa", "Arhavi", "Yusufeli", "Borçka"],

            "Aydin": ["Aydin", "Nazilli", "Söke", "Kusadasi", "Didim"],

            "Balikesir": ["Balikesir", "Bandirma", "Edremit", "Gönen", "Burhaniye"],

            "Bilecik": ["Bilecik", "Bozüyük", "Sögüt", "Osmaneli", "Pazaryeri"],

            "Bitlis": ["Bitlis", "Tatvan", "Ahlat", "Hizan", "Mutki"],

            "Bolu": ["Bolu", "Gerede", "Mudurnu", "Dörtdivan", "Yeniçaga"],

            "Burdur": ["Burdur", "Bucak", "Gölhisar", "Tefenni", "Yesilova"],

            "Bursa": ["Bursa", "Inegöl", "Gemlik", "Mustafakemalpasa", "Orhangazi"],

            "Çanakkale": ["Çanakkale", "Bigadiç", "Çan", "Biga", "Ezine"],

            "Çankiri": ["Çankiri", "Çerkes", "Ilgaz", "Orta", "Sabanözü"],

            "Çorum": ["Çorum", "Iskilip", "Sungurlu", "Osmancik", "Alaca"],

            "Denizli": ["Denizli", "Pamukkale", "Çivril", "Tavas", "Buldan"],

            "Diyarbakir": ["Diyarbakir", "Bismil", "Silvan", "Ergani", "Çinar"],

            "Edirne": ["Edirne", "Kesan", "Uzunköprü", "Ipsala", "Havsa"],

            "Elazig": ["Elazig", "Kovancilar", "Keban", "Maden", "Sivrice"],

            "Erzincan": ["Erzincan", "Refahiye", "Çayirli", "Iliç", "Kemah"],

            "Erzurum": ["Erzurum", "Pasinler", "Horasan", "Oltu", "Ispir"],

            "Eskisehir": ["Eskisehir", "Sivrihisar", "Çifteler", "Alpu", "Mihaliççik"],

            "Gaziantep": ["Gaziantep", "Sahinbey", "Sehitkamil", "Nizip", "Islahiye"],

            "Giresun": ["Giresun", "Bulancak", "Espiye", "Tirebolu", "Görele"],

            "Gümüshane": ["Gümüshane", "Kelkit", "Siran", "Köse", "Torul"],

            "Hakkari": ["Hakkari", "Yüksekova", "Çukurca", "Semdinli", "Derecik"],

            "Hatay": ["Antakya", "Iskenderun", "Dörtyol", "Reyhanli", "Samandag"],

            "Isparta": ["Isparta", "Yalvaç", "Egirdir", "Sarkikaraagaç", "Gelendost"],

            "Mersin": ["Mersin", "Tarsus", "Silifke", "Erdemli", "Anamur"],

            "Istanbul": ["Istanbul", "Kadiköy", "Üsküdar", "Besiktas", "Fatih", "Beyoglu"],

            "Izmir": ["Izmir", "Bornova", "Karsiyaka", "Buca", "Konak", "Çesme"],

            "Kars": ["Kars", "Sarikamis", "Kagizman", "Digor", "Selim"],

            "Kastamonu": ["Kastamonu", "Tasköprü", "Inebolu", "Tosya", "Cide"],

            "Kayseri": ["Kayseri", "Develi", "Yahyali", "Bünyan", "Pinarbasi"],

            "Kirklareli": ["Kirklareli", "Lüleburgaz", "Babaeski", "Vize", "Pinarhisar"],

            "Kirsehir": ["Kirsehir", "Kaman", "Mucur", "Çiçekdagi", "Akpinar"],

            "Kocaeli": ["Izmit", "Gebze", "Darica", "Körfez", "Gölcük"],

            "Konya": ["Konya", "Eregli", "Aksehir", "Beysehir", "Çumra"],

            "Kütahya": ["Kütahya", "Tavsanli", "Simav", "Emet", "Gediz"],

            "Malatya": ["Malatya", "Battalgazi", "Dogansehir", "Yesilyurt", "Akçadag"],

            "Manisa": ["Manisa", "Akhisar", "Salihli", "Turgutlu", "Soma"],

            "Kahramanmaras": ["Kahramanmaras", "Elbistan", "Afsin", "Pazarcik", "Göksun"],

            "Mardin": ["Mardin", "Kiziltepe", "Nusaybin", "Derik", "Mazidagi"],

            "Mugla": ["Mugla", "Bodrum", "Fethiye", "Marmaris", "Milas"],

            "Mus": ["Mus", "Bulanik", "Malazgirt", "Varto", "Korkut"],

            "Nevsehir": ["Nevsehir", "Ürgüp", "Avanos", "Gülsehir", "Hacibektas"],

            "Nigde": ["Nigde", "Bor", "Çiftlik", "Ulukisla", "Altunhisar"],

            "Ordu": ["Ordu", "Ünye", "Fatsa", "Persembe", "Kumru"],

            "Rize": ["Rize", "Çayeli", "Pazar", "Ardesen", "Findikli"],

            "Sakarya": ["Adapazari", "Sapanca", "Akyazi", "Hendek", "Karapürçek"],

            "Samsun": ["Samsun", "Bafra", "Çarsamba", "Terme", "Vezirköprü"],

            "Siirt": ["Siirt", "Kurtalan", "Pervari", "Sirvan", "Baykan"],

            "Sinop": ["Sinop", "Boyabat", "Ayancik", "Gerze", "Duragan"],

            "Sivas": ["Sivas", "Sarkisla", "Yildizeli", "Zara", "Susehri"],

            "Tekirdag": ["Tekirdag", "Çorlu", "Çerkezköy", "Malkara", "Saray"],

            "Tokat": ["Tokat", "Turhal", "Zile", "Erbaa", "Niksar"],

            "Trabzon": ["Trabzon", "Akçaabat", "Arakli", "Vakfikebir", "Of"],

            "Tunceli": ["Tunceli", "Pertek", "Çemisgezek", "Hozat", "Mazgirt"],

            "Sanliurfa": ["Sanliurfa", "Siverek", "Viransehir", "Ceylanpinar", "Birecik"],

            "Usak": ["Usak", "Banaz", "Esme", "Sivasli", "Ulubey"],

            "Van": ["Van", "Ercis", "Baskale", "Çatak", "Gevas"],

            "Yozgat": ["Yozgat", "Sorgun", "Akdagmadeni", "Yerköy", "Çekerek"],

            "Zonguldak": ["Zonguldak", "Kozlu", "Çaycuma", "Devrek", "Eregli"]

        },

        "UAE": {

            "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Madinat Zayed", "Ruwais", "Liwa", "Ghayathi"],

            "Dubai": ["Dubai", "Jebel Ali", "Hatta"],

            "Sharjah": ["Sharjah", "Khor Fakkan", "Kalba", "Dibba Al-Hisn", "Al Dhaid"],

            "Ajman": ["Ajman", "Masfout", "Manama"],

            "Ras Al Khaimah": ["Ras Al Khaimah", "Al Jazirah Al Hamra", "Khatt", "Rams"],

            "Fujairah": ["Fujairah", "Dibba Al-Fujairah"],

            "Umm Al Quwain": ["Umm Al Quwain", "Falaj Al Mualla"]

        },

        "Qatar": {

            "Doha": ["Doha", "West Bay", "Al Dafna", "Al Sadd", "Bin Mahmoud", "Old Doha"],

            "Al Rayyan": ["Al Rayyan", "Al Wakrah Camp", "Education City", "Al Gharrafa", "Al Wajba"],

            "Al Wakrah": ["Al Wakrah", "Al Wukair", "Mesaieed"],

            "Umm Salal": ["Umm Salal Mohammed", "Umm Salal Ali"],

            "Al Daayen": ["Lusail", "Al Daayen", "Umm Qarn"],

            "Al Khor": ["Al Khor", "Al Thakhira"],

            "Al Shamal": ["Madinat ash Shamal", "Ar Ru'ays"]

        },

        "Saudi Arabia": {

            "Riyadh": ["Riyadh", "Diriyah", "Al Kharj", "Al Majma'ah", "Dawadmi", "Shaqra"],

            "Makkah": ["Makkah", "Jeddah", "Taif", "Rabigh", "Al Lith"],

            "Madinah": ["Madinah", "Yanbu", "Al Ula", "Badr"],

            "Eastern Province – Dammam": ["Dammam", "Khobar", "Dhahran", "Jubail", "Qatif", "Ras Tanura", "Al Ahsa (Hofuf)"],

            "Asir": ["Abha", "Khamis Mushait", "Ahad Rifaidah", "Mahayel Aseer"],

            "Jazan": ["Jazan", "Sabya", "Abu Arish", "Al Ardah"],

            "Najran": ["Najran", "Sharurah", "Hubuna"],

            "Al Qassim": ["Buraidah", "Unaizah", "Al Rass", "Al Bukayriyah"],

            "Tabuk": ["Tabuk", "Duba", "Umluj", "Tayma"],

            "Hail": ["Hail", "Baqaa", "Ghazalah"],

            "Al Jawf": ["Sakaka", "Qurayyat", "Dumat Al Jandal"],

            "Northern Borders": ["Arar", "Rafha", "Turaif"],

            "Al Baha": ["Al Baha", "Baljurashi", "Al Makhwah"]

        },

        "Oman": {

            "Muscat": ["Muscat", "Muttrah", "Ruwi", "Seeb", "Bawshar", "Al Amerat"],

            "Dhofar": ["Salalah", "Taqah", "Mirbat", "Thumrait", "Rakhyut"],

            "Al Batinah North": ["Sohar", "Shinas", "Liwa", "Saham", "Al Khaburah"],

            "Al Batinah South": ["Rustaq", "Awabi", "Nakhal", "Wadi Al Maawil"],

            "Al Dakhiliyah": ["Nizwa", "Bahla", "Adam", "Manah", "Izki", "Samail"],

            "Al Sharqiyah North": ["Ibra", "Bidiyah", "Al Mudhaibi", "Qabil"],

            "Al Sharqiyah South": ["Sur", "Jalan Bani Bu Ali", "Jalan Bani Bu Hassan", "Masirah"],

            "Al Dhahirah": ["Ibri", "Yanqul", "Dhank"],

            "Al Buraimi": ["Al Buraimi", "Mahdah", "Al Sunaynah"],

            "Al Wusta": ["Haima", "Duqm", "Mahout"],

            "Musandam": ["Khasab", "Bukha", "Dibba Al-Bayah"]

        },

        "Kuwait": {

            "Al Asimah (Capital)": ["Kuwait City", "Sharq", "Dasman", "Qibla", "Mirqab", "Dasma"],

            "Hawalli": ["Hawalli", "Salmiya", "Jabriya", "Bayan", "Mishref", "Rumaithiya", "Salwa"],

            "Farwaniya": ["Farwaniya", "Khaitan", "Abbassiya", "Riggae", "Jleeb Al-Shuyoukh", "Omariya"],

            "Ahmadi": ["Ahmadi", "Fahaheel", "Mangaf", "Mahboula", "Riqqa", "Hadiya", "Sabahiya"],

            "Jahra": ["Jahra", "Qasr", "Sulaibiya", "Taima", "Saad Al Abdullah"],

            "Mubarak Al-Kabeer": ["Mubarak Al-Kabeer", "Sabah Al-Salem", "Al-Adan", "Qurain", "Abu Al-Hasaniya", "Abu Futaira"]

        },

        "Bahrain": {

            "Capital Governorate": ["Manama", "Seef", "Juffair", "Diplomatic Area", "Sanabis", "Karbabad"],

            "Muharraq Governorate": ["Muharraq", "Hidd", "Arad", "Galali", "Diyar Al Muharraq"],

            "Northern Governorate": ["A'ali", "Barbar", "Budaiya", "Diraz", "Hamad Town", "Saar"],

            "Southern Governorate": ["Riffa", "Isa Town", "Sakhir", "Zallaq", "Awali", "East Riffa", "West Riffa"]

        },

        "Singapore": {

            "Central Region": ["Singapore (CBD)", "Orchard", "Marina Bay", "Bugis", "Chinatown", "Little India", "Tiong Bahru"],

            "East Region": ["Tampines", "Bedok", "Pasir Ris", "Changi", "Simei"],

            "West Region": ["Jurong East", "Jurong West", "Clementi", "Bukit Batok", "Bukit Panjang", "Tuas"],

            "North Region": ["Woodlands", "Yishun", "Sembawang", "Admiralty"],

            "North-East Region": ["Hougang", "Sengkang", "Punggol", "Serangoon"]

        },

        "Malaysia": {

            "Johor": ["Johor Bahru", "Iskandar Puteri", "Batu Pahat", "Kluang", "Muar", "Pontian"],

            "Kedah": ["Alor Setar", "Sungai Petani", "Kulim", "Langkawi"],

            "Kelantan": ["Kota Bharu", "Pasir Mas", "Tumpat", "Tanah Merah"],

            "Melaka": ["Melaka City", "Ayer Keroh", "Alor Gajah", "Jasin"],

            "Negeri Sembilan": ["Seremban", "Port Dickson", "Nilai", "Tampin"],

            "Pahang": ["Kuantan", "Temerloh", "Bentong", "Raub", "Cameron Highlands"],

            "Penang (Pulau Pinang)": ["George Town", "Butterworth", "Bukit Mertajam", "Bayan Lepas"],

            "Perak": ["Ipoh", "Taiping", "Teluk Intan", "Batu Gajah", "Lumut"],

            "Perlis": ["Kangar", "Kuala Perlis"],

            "Sabah": ["Kota Kinabalu", "Sandakan", "Tawau", "Lahad Datu"],

            "Sarawak": ["Kuching", "Miri", "Sibu", "Bintulu"],

            "Selangor": ["Shah Alam", "Petaling Jaya", "Subang Jaya", "Klang", "Cyberjaya"],

            "Terengganu": ["Kuala Terengganu", "Dungun", "Kemaman", "Marang"],

            "Federal Territory of Kuala Lumpur": ["Kuala Lumpur"],

            "Federal Territory of Putrajaya": ["Putrajaya"],

            "Federal Territory of Labuan": ["Labuan"]

        },

        "Hong Kong": {

            "Hong Kong Island": ["Central", "Admiralty", "Wan Chai", "Causeway Bay", "North Point", "Quarry Bay", "Aberdeen"],

            "Kowloon": ["Tsim Sha Tsui", "Mong Kok", "Yau Ma Tei", "Jordan", "Sham Shui Po", "Kowloon City", "Hung Hom"],

            "New Territories": ["Sha Tin", "Tai Po", "Tsuen Wan", "Tuen Mun", "Yuen Long", "Fanling", "Sheung Shui"],

            "Outlying Islands": ["Lantau Island", "Tung Chung", "Cheung Chau", "Lamma Island", "Peng Chau"]

        },

        "Taiwan": {

            "Taipei City": ["Taipei", "Zhongshan", "Wanhua", "Da'an", "Xinyi"],

            "New Taipei City": ["Banqiao", "Xinzhuang", "Tamsui", "Sanchong", "Linkou"],

            "Taoyuan City": ["Taoyuan", "Zhongli", "Bade", "Luzhu"],

            "Taichung City": ["Taichung", "Fengyuan", "Dali", "Beitun"],

            "Tainan City": ["Tainan", "Yongkang", "Rende"],

            "Kaohsiung City": ["Kaohsiung", "Zuoying", "Lingya", "Xiaogang"]

        },

        "South Korea": {

            "Seoul": ["Seoul", "Gangnam", "Jongno", "Mapo", "Songpa", "Yeongdeungpo"],

            "Busan": ["Busan", "Haeundae", "Suyeong", "Dongnae", "Sasang"],

            "Incheon": ["Incheon", "Bupyeong", "Namdong", "Yeonsu", "Songdo"],

            "Daegu": ["Daegu", "Suseong", "Dalseo", "Dong"],

            "Daejeon": ["Daejeon", "Yuseong", "Seo", "Dong"],

            "Gwangju": ["Gwangju", "Buk", "Seo", "Gwangsan"],

            "Ulsan": ["Ulsan", "Nam", "Dong", "Buk"],

            "Gyeonggi-do": ["Suwon", "Seongnam", "Goyang", "Yongin", "Bucheon", "Ansan", "Anyang"],

            "Gangwon-do": ["Chuncheon", "Wonju", "Gangneung", "Donghae"],

            "Chungcheongbuk-do": ["Cheongju", "Chungju", "Jecheon"],

            "Chungcheongnam-do": ["Cheonan", "Asan", "Seosan", "Dangjin"],

            "Jeollabuk-do": ["Jeonju", "Iksan", "Gunsan"],

            "Jeollanam-do": ["Mokpo", "Yeosu", "Suncheon", "Gwangyang"],

            "Gyeongsangbuk-do": ["Pohang", "Gumi", "Andong", "Gyeongju"],

            "Gyeongsangnam-do": ["Changwon", "Gimhae", "Jinju", "Yangsan"],

            "Jeju Special Self-Governing Province": ["Jeju City", "Seogwipo"]

        },

        "Japan": {

            "Tokyo": ["Tokyo", "Shinjuku", "Shibuya", "Minato", "Chiyoda", "Taito", "Ikebukuro"],

            "Kanagawa": ["Yokohama", "Kawasaki", "Yokosuka", "Kamakura"],

            "Osaka": ["Osaka", "Sakai", "Toyonaka", "Higashiosaka"],

            "Aichi": ["Nagoya", "Toyota", "Okazaki", "Ichinomiya"],

            "Saitama": ["Saitama", "Kawaguchi", "Kawagoe", "Tokorozawa"],

            "Chiba": ["Chiba", "Funabashi", "Matsudo", "Ichikawa"],

            "Hyogo": ["Kobe", "Himeji", "Nishinomiya", "Amagasaki"],

            "Hokkaido": ["Sapporo", "Hakodate", "Asahikawa"],

            "Fukuoka": ["Fukuoka", "Kitakyushu", "Kurume"],

            "Hiroshima": ["Hiroshima", "Fukuyama", "Kure"],

            "Kyoto": ["Kyoto", "Uji", "Kameoka"],

            "Okinawa": ["Naha", "Okinawa City", "Uruma"]

        },

        "Germany": {

            "Bavaria (Bayern)": ["Munich", "Nuremberg", "Augsburg", "Regensburg", "Würzburg"],

            "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen", "Duisburg", "Bochum"],

            "Baden-Württemberg": ["Stuttgart", "Mannheim", "Karlsruhe", "Freiburg", "Heidelberg"],

            "Hesse (Hessen)": ["Frankfurt am Main", "Wiesbaden", "Darmstadt", "Kassel", "Offenbach"],

            "Lower Saxony (Niedersachsen)": ["Hanover", "Wolfsburg", "Braunschweig", "Oldenburg", "Osnabrück"],

            "Berlin (City State)": ["Berlin", "Mitte", "Charlottenburg", "Neukölln", "Kreuzberg"],

            "Hamburg (City State)": ["Hamburg", "Altona", "Wandsbek", "Eimsbüttel"],

            "Saxony (Sachsen)": ["Dresden", "Leipzig", "Chemnitz"],

            "Rhineland-Palatinate (Rheinland-Pfalz)": ["Mainz", "Ludwigshafen", "Koblenz", "Trier"],

            "Schleswig-Holstein": ["Kiel", "Lübeck", "Flensburg", "Neumünster"],

            "Brandenburg": ["Potsdam", "Cottbus", "Brandenburg an der Havel"],

            "Saarland": ["Saarbrücken", "Neunkirchen", "Homburg"],

            "Bremen (City State)": ["Bremen", "Bremerhaven"],

            "Mecklenburg-Vorpommern": ["Rostock", "Schwerin", "Wismar"],

            "Thuringia (Thüringen)": ["Erfurt", "Jena", "Weimar"],

            "Saxony-Anhalt (Sachsen-Anhalt)": ["Magdeburg", "Halle (Saale)", "Dessau-Roßlau"]

        },

        "Netherlands": {
            "Noord-Holland": ["Amsterdam", "Haarlem"],
            "Zuid-Holland": ["Rotterdam", "The Hague", "Leiden"],
            "Utrecht": ["Utrecht"],
            "Noord-Brabant": ["Eindhoven", "Tilburg"],
            "Gelderland": ["Arnhem", "Nijmegen"],
            "Overijssel": ["Enschede", "Zwolle"],
            "Limburg": ["Maastricht"],
            "Groningen": ["Groningen"],
            "Friesland": ["Leeuwarden"],
            "Drenthe": ["Assen"],
            "Flevoland": ["Almere", "Lelystad"],
            "Zeeland": ["Middelburg"]
        },
        "Poland": {
            "Masovian Voivodeship": ["Warsaw", "Radom", "Plock", "Siedlce", "Pruszków", "Legionowo", "Ostroleka"],

            "Lesser Poland Voivodeship": ["Krakow", "Tarnów", "Nowy Sacz", "Oswiecim", "Chrzanów", "Olkusz", "Zakopane"],

            "Silesian Voivodeship": ["Katowice", "Czestochowa", "Sosnowiec", "Gliwice", "Zabrze", "Bytom", "Ruda Slaska", "Rybnik"],

            "Greater Poland Voivodeship": ["Poznan", "Kalisz", "Konin", "Pila", "Ostrów Wielkopolski", "Gniezno", "Leszno"],

            "Lower Silesian Voivodeship": ["Wroclaw", "Walbrzych", "Legnica", "Jelenia Góra", "Lubin", "Glogów", "Swidnica"],

            "Lódz Voivodeship": ["Lódz", "Piotrków Trybunalski", "Pabianice", "Tomaszów Mazowiecki", "Zgierz", "Skierniewice"],

            "Pomeranian Voivodeship": ["Gdansk", "Gdynia", "Sopot", "Tczew", "Starogard Gdanski", "Wejherowo", "Koscierzyna"],

            "West Pomeranian Voivodeship": ["Szczecin", "Koszalin", "Swinoujscie", "Stargard", "Police", "Gryfino", "Kolobrzeg"],

            "Lublin Voivodeship": ["Lublin", "Chelm", "Zamosc", "Biala Podlaska", "Pulawy", "Krasnik"],

            "Podlaskie Voivodeship": ["Bialystok", "Suwalki", "Lomza", "Augustów", "Sokólka", "Hajnówka"],

            "Swietokrzyskie Voivodeship": ["Kielce", "Ostrowiec Swietokrzyski", "Starachowice", "Skarzysko-Kamienna", "Sandomierz"],

            "Warmian-Masurian Voivodeship": ["Olsztyn", "Elblag", "Elk", "Ilawa", "Mragowo", "Gizycko"],

            "Lubusz Voivodeship": ["Gorzów Wielkopolski", "Zielona Góra", "Nowa Sól", "Zary", "Zagan", "Miedzyrzecz"],

            "Kuyavian-Pomeranian Voivodeship": ["Bydgoszcz", "Torun", "Wloclawek", "Grudziadz", "Inowroclaw", "Brodnica"],

            "Opole Voivodeship": ["Opole", "Kedzierzyn-Kozle", "Nysa", "Brzeg", "Prudnik", "Strzelce Opolskie"],

            "Subcarpathian Voivodeship": ["Rzeszów", "Przemysl", "Stalowa Wola", "Mielec", "Tarnobrzeg", "Krosno", "Jaroslaw"]

        },



        "Ireland": {

            "County Dublin": ["Dublin City", "Tallaght", "Dún Laoghaire", "Swords", "Blanchardstown", "Lucan", "Malahide"],

            "County Cork": ["Cork City", "Ballincollig", "Carrigaline", "Midleton", "Cobh", "Mallow", "Youghal"],

            "County Galway": ["Galway City", "Tuam", "Ballinasloe", "Loughrea", "Oranmore", "Athenry", "Clifden"],

            "County Limerick": ["Limerick City", "Newcastle West", "Abbeyfeale", "Rathkeale", "Kilmallock", "Adare"],

            "County Waterford": ["Waterford City", "Dungarvan", "Tramore", "Dunmore East", "Lismore", "Portlaw"],

            "County Kerry": ["Tralee", "Killarney", "Listowel", "Kenmare", "Dingle", "Cahersiveen"],

            "County Clare": ["Ennis", "Shannon", "Kilrush", "Ennistymon", "Kilkee", "Newmarket-on-Fergus"],

            "County Wexford": ["Wexford Town", "Enniscorthy", "Gorey", "New Ross", "Rosslare", "Bunclody"],

            "County Mayo": ["Castlebar", "Ballina", "Westport", "Claremorris", "Swinford", "Belmullet"],

            "County Donegal": ["Letterkenny", "Buncrana", "Ballybofey", "Donegal Town", "Carndonagh", "Bundoran"],

            "County Kildare": ["Naas", "Newbridge", "Maynooth", "Celbridge", "Leixlip", "Athy", "Kildare Town"],

            "County Meath": ["Navan", "Drogheda (part)", "Trim", "Ashbourne", "Kells", "Dunboyne", "Duleek"],

            "County Wicklow": ["Bray", "Greystones", "Arklow", "Wicklow Town", "Rathdrum", "Blessington"],

            "County Louth": ["Dundalk", "Drogheda (part)", "Ardee", "Carlingford", "Dunleer"],

            "County Tipperary": ["Clonmel", "Nenagh", "Thurles", "Tipperary Town", "Carrick-on-Suir", "Roscrea", "Cahir"],

            "County Kilkenny": ["Kilkenny City", "Callan", "Thomastown", "Graiguenamanagh", "Castlecomer"]

        },



        "Canada": {

            "Ontario": ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Markham", "Vaughan", "Kitchener", "Windsor"],

            "Quebec": ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke", "Saguenay", "Trois-Rivières"],

            "British Columbia": ["Vancouver", "Surrey", "Burnaby", "Richmond", "Kelowna", "Coquitlam", "Langley", "Delta", "Victoria"],

            "Alberta": ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "St. Albert", "Medicine Hat", "Grande Prairie", "Airdrie"],

            "Manitoba": ["Winnipeg", "Brandon", "Thompson", "Steinbach", "Portage la Prairie", "Winkler", "Selkirk"],

            "Saskatchewan": ["Saskatoon", "Regina", "Prince Albert", "Moose Jaw", "Yorkton", "Swift Current", "North Battleford"],

            "Nova Scotia": ["Halifax", "Sydney", "Dartmouth", "Truro", "New Glasgow", "Glace Bay", "Amherst"],

            "New Brunswick": ["Moncton", "Saint John", "Fredericton", "Dieppe", "Miramichi", "Edmundston", "Bathurst"],

            "Newfoundland and Labrador": ["St. John's", "Mount Pearl", "Corner Brook", "Grand Falls-Windsor", "Gander", "Labrador City"],

            "Prince Edward Island": ["Charlottetown", "Summerside", "Stratford", "Montague", "Kensington", "Alberton"],

            "Northwest Territories": ["Yellowknife", "Hay River", "Inuvik", "Fort Smith", "BehchokoÌ€"],

            "Yukon": ["Whitehorse", "Dawson City", "Watson Lake", "Haines Junction", "Carmacks"],

            "Nunavut": ["Iqaluit", "Rankin Inlet", "Arviat", "Baker Lake", "Cambridge Bay", "Pangnirtung"]

        },



        "Italy": {

            "Lombardy": ["Milan", "Bergamo", "Brescia", "Monza", "Como", "Varese", "Lecco", "Cremona", "Mantua"],

            "Lazio": ["Rome", "Latina", "Frosinone", "Viterbo", "Rieti", "Guidonia Montecelio", "Civitavecchia"],

            "Campania": ["Naples", "Salerno", "Caserta", "Benevento", "Avellino", "Pompei", "Sorrento", "Capri"],

            "Sicily": ["Palermo", "Catania", "Messina", "Syracuse", "Trapani", "Agrigento", "Ragusa", "Caltanissetta"],

            "Veneto": ["Venice", "Verona", "Padua", "Vicenza", "Treviso", "Belluno", "Rovigo", "Chioggia"],

            "Piedmont": ["Turin", "Novara", "Alessandria", "Asti", "Cuneo", "Vercelli", "Biella", "Verbania"],

            "Emilia-Romagna": ["Bologna", "Parma", "Modena", "Reggio Emilia", "Ravenna", "Ferrara", "Forlì", "Rimini", "Piacenza"],

            "Tuscany": ["Florence", "Pisa", "Lucca", "Arezzo", "Siena", "Prato", "Livorno", "Grosseto", "Massa"],

            "Apulia": ["Bari", "Lecce", "Taranto", "Foggia", "Brindisi", "Barletta", "Trani", "Andria"],

            "Liguria": ["Genoa", "La Spezia", "Savona", "Sanremo", "Imperia", "Rapallo", "Portofino"],

            "Marche": ["Ancona", "Pesaro", "Urbino", "Macerata", "Ascoli Piceno", "Fermo", "Senigallia"],

            "Abruzzo": ["L'Aquila", "Pescara", "Chieti", "Teramo", "Avezzano", "Vasto", "Sulmona"],

            "Umbria": ["Perugia", "Assisi", "Terni", "Foligno", "Spoleto", "Città di Castello", "Gubbio"],

            "Calabria": ["Reggio Calabria", "Catanzaro", "Cosenza", "Crotone", "Vibo Valentia", "Lamezia Terme"],

            "Sardinia": ["Cagliari", "Sassari", "Olbia", "Nuoro", "Oristano", "Alghero", "Carbonia"],

            "Friuli-Venezia Giulia": ["Trieste", "Udine", "Pordenone", "Gorizia", "Monfalcone", "Cervignano del Friuli"],

            "Trentino-Alto Adige": ["Trento", "Bolzano", "Merano", "Brixen", "Rovereto", "Pergine Valsugana"],

            "Molise": ["Campobasso", "Isernia", "Termoli", "Venafro", "Bojano", "Larino"],

            "Basilicata": ["Potenza", "Matera", "Melfi", "Pisticci", "Lauria", "Bernalda"],

            "Aosta Valley": ["Aosta", "Courmayeur", "Cervinia", "La Thuile", "Saint-Vincent", "Pré-Saint-Didier"]

        },

        "Romania": {

            "Alba": ["Alba Iulia", "Sebe?", "Blaj", "Aiud", "Cugir"],

            "Arad": ["Arad", "Ineu", "Chi?ineu-Cri?", "Lipova", "Pâncota"],

            "Arge?": ["Pite?ti", "Curtea de Arge?", "Câmpulung", "Mioveni", "Coste?ti"],

            "Bacau": ["Bacau", "One?ti", "Moine?ti", "Comane?ti", "Buhu?i"],

            "Bihor": ["Oradea", "Salonta", "Beiu?", "Marghita", "Ale?d"],

            "Bistri?a-Nasaud": ["Bistri?a", "Beclean", "Nasaud", "Sângeorz-Bai"],

            "Boto?ani": ["Boto?ani", "Dorohoi", "Darabani", "Saveni", "Flamânzi"],

            "Braila": ["Braila", "Ianca", "Însura?ei", "Faurei"],

            "Bra?ov": ["Bra?ov", "Fagara?", "Sacele", "Codlea", "Zarne?ti"],

            "Bucure?ti (Capital)": ["Bucharest", "Sector 1", "Sector 2", "Sector 3", "Sector 4", "Sector 5", "Sector 6"],

            "Buzau": ["Buzau", "Râmnicu Sarat", "Nehoiu", "Pogoanele"],

            "Calara?i": ["Calara?i", "Olteni?a", "Lehliu Gara", "Bude?ti"],

            "Cara?-Severin": ["Re?i?a", "Caransebe?", "Boc?a", "Oravi?a", "Moldova Noua"],

            "Cluj": ["Cluj-Napoca", "Turda", "Dej", "Câmpia Turzii", "Gherla"],

            "Constan?a": ["Constan?a", "Mangalia", "Medgidia", "Navodari", "Cernavoda"],

            "Covasna": ["Sfântu Gheorghe", "Târgu Secuiesc", "Covasna", "Întorsura Buzaului"],

            "Dâmbovi?a": ["Târgovi?te", "Moreni", "Pucioasa", "Gae?ti", "Titu"],

            "Dolj": ["Craiova", "Baile?ti", "Calafat", "Filia?i", "Segarcea"],

            "Gala?i": ["Gala?i", "Tecuci", "Târgu Bujor", "Bere?ti"],

            "Giurgiu": ["Giurgiu", "Bolintin-Vale", "Mihaile?ti"],

            "Gorj": ["Târgu Jiu", "Motru", "Rovinari", "Novaci", "Bumbe?ti-Jiu"],

            "Harghita": ["Miercurea Ciuc", "Odorheiu Secuiesc", "Gheorgheni", "Topli?a"],

            "Hunedoara": ["Deva", "Hunedoara", "Petro?ani", "Lupeni", "Vulcan"],

            "Ialomi?a": ["Slobozia", "Fete?ti", "Urziceni", "?andarei"],

            "Ia?i": ["Ia?i", "Pa?cani", "Hârlau", "Târgu Frumos"],

            "Ilfov": ["Buftea", "Voluntari", "Pantelimon", "Pope?ti-Leordeni", "Bragadiru"],

            "Maramure?": ["Baia Mare", "Sighetu Marma?iei", "Bor?a", "Vi?eu de Sus"],

            "Mehedin?i": ["Drobeta-Turnu Severin", "Or?ova", "Vânju Mare", "Strehaia"],

            "Mure?": ["Târgu Mure?", "Reghin", "Sighi?oara", "Târnaveni", "Ludu?"],

            "Neam?": ["Piatra Neam?", "Roman", "Târgu Neam?", "Bicaz"],

            "Olt": ["Slatina", "Caracal", "Bal?", "Corabia", "Scornice?ti"],

            "Prahova": ["Ploie?ti", "Câmpina", "Sinaia", "Bu?teni", "Azuga"],

            "Salaj": ["Zalau", "?imleu Silvaniei", "Jibou", "Cehu Silvaniei"],

            "Satu Mare": ["Satu Mare", "Carei", "Negre?ti-Oa?", "Ta?nad"],

            "Sibiu": ["Sibiu", "Media?", "Cisnadie", "Agnita", "Avrig"],

            "Suceava": ["Suceava", "Boto?ani", "Falticeni", "Radau?i", "Câmpulung Moldovenesc"],

            "Teleorman": ["Alexandria", "Rosiori de Vede", "Turnu Magurele", "Zimnicea"],

            "Timi?": ["Timi?oara", "Lugoj", "Sânnicolau Mare", "Jimbolia"],

            "Tulcea": ["Tulcea", "Babadag", "Macin", "Sulina"],

            "Vaslui": ["Vaslui", "Bârlad", "Hu?i", "Negre?ti"],

            "Vâlcea": ["Râmnicu Vâlcea", "Draga?ani", "Baile Olane?ti", "Calimane?ti"],

            "Vrancea": ["Foc?ani", "Adjud", "Mara?e?ti", "Panciu"]

        },

        "Hungary": {

            "Bács-Kiskun": ["Kecskemét", "Baja", "Kalocsa", "Kiskunfélegyháza", "Kiskunhalas"],

            "Baranya": ["Pécs", "Komló", "Mohács", "Szigetvár", "Siklós"],

            "Békés": ["Békéscsaba", "Gyula", "Orosháza", "Szarvas", "Békés"],

            "Borsod-Abaúj-Zemplén": ["Miskolc", "Ózd", "Kazincbarcika", "Sátoraljaújhely", "Tiszaújváros"],

            "Csongrád-Csanád": ["Szeged", "Hódmezovásárhely", "Makó", "Szentes", "Mórahalom"],

            "Fejér": ["Székesfehérvár", "Dunaújváros", "Mór", "Bicske", "Gárdony"],

            "Gyor-Moson-Sopron": ["Gyor", "Sopron", "Mosonmagyaróvár", "Csorna", "Kapuvár"],

            "Hajdú-Bihar": ["Debrecen", "Hajdúböszörmény", "Hajdúszoboszló", "Berettyóújfalu", "Balmazújváros"],

            "Heves": ["Eger", "Hatvan", "Gyöngyös", "Füzesabony", "Heves"],

            "Jász-Nagykun-Szolnok": ["Szolnok", "Jászberény", "Karcag", "Törökszentmiklós", "Mezotúr"],

            "Komárom-Esztergom": ["Tatabánya", "Esztergom", "Komárom", "Oroszlány", "Tata"],

            "Nógrád": ["Salgótarján", "Balassagyarmat", "Pásztó", "Bátonyterenye", "Rétság"],

            "Pest": ["Érd", "Gödöllo", "Vác", "Cegléd", "Dunakeszi"],

            "Somogy": ["Kaposvár", "Siófok", "Marcali", "Barcs", "Fonyód"],

            "Szabolcs-Szatmár-Bereg": ["Nyíregyháza", "Kisvárda", "Mátészalka", "Nyírbátor", "Fehérgyarmat"],

            "Tolna": ["Szekszárd", "Dombóvár", "Paks", "Tamási", "Bonyhád"],

            "Vas": ["Szombathely", "Sárvár", "Körmend", "Szentgotthárd", "Celldömölk"],

            "Veszprém": ["Veszprém", "Ajka", "Várpalota", "Pápa", "Balatonfüred"],

            "Zala": ["Zalaegerszeg", "Nagykanizsa", "Keszthely", "Lenti", "Zalaszentgrót"],

            "Budapest (Capital)": ["Budapest", "District I", "District II", "District III", "District IV", "District V"]

        },

        "Lithuania": {

            "Alytus County": ["Alytus", "Varena", "Druskininkai", "Lazdijai"],

            "Kaunas County": ["Kaunas", "Jonava", "Kedainiai", "Kaišiadorys", "Prienai"],

            "Klaipeda County": ["Klaipeda", "Mažeikiai", "Plunge", "Kretinga", "Palanga"],

            "Marijampole County": ["Marijampole", "Vilkaviškis", "Šakiai", "Kazlu Ruda"],

            "Panevežys County": ["Panevežys", "Kupiškis", "Rokiškis", "Biržai", "Pasvalys"],

            "Šiauliai County": ["Šiauliai", "Radviliškis", "Kelme", "Pakruojis", "Joniškis"],

            "Taurage County": ["Taurage", "Šilute", "Jurbarkas", "Pagegiai"],

            "Telšiai County": ["Telšiai", "Mažeikiai", "Plunge", "Rietavas"],

            "Utena County": ["Utena", "Visaginas", "Anykšciai", "Moletai", "Zarasai"],

            "Vilnius County": ["Vilnius (Capital)", "Ukmerge", "Elektrenai", "Šalcininkai", "Trakai"]

        },

        "Czech Republic": {

            "Prague": ["Prague"],

            "Central Bohemian": ["Prague", "Brno", "Ostrava"],

            "South Bohemian": ["Ceské Budejovice"],

            "Plzen": ["Plzen"],

            "Karlovy Vary": ["Karlovy Vary"],

            "Ústí nad Labem": ["Ústí nad Labem"],

            "Liberec": ["Liberec"],

            "Hradec Králové": ["Hradec Králové"],

            "Pardubice": ["Pardubice"],

            "Vysocina": ["Jihlava"],

            "South Moravian": ["Brno"],

            "Olomouc": ["Olomouc"],

            "Zlín": ["Zlín"],

            "Moravian-Silesian": ["Ostrava"]

        },

        "Slovakia": {

            "Bratislava": ["Bratislava"],

            "Trnava": ["Trnava"],

            "Trencín": ["Trencín"],

            "Nitra": ["Nitra"],

            "Žilina": ["Žilina", "Martin"],

            "Banská Bystrica": ["Banská Bystrica"],

            "Prešov": ["Prešov", "Poprad"],

            "Košice": ["Košice"]

        },

        "Belgium": {

            "Antwerp": ["Antwerp"],

            "East Flanders": ["Ghent"],

            "West Flanders": ["Bruges"],

            "Limburg": ["Hasselt"],

            "Flemish Brabant": ["Leuven"],

            "Walloon Brabant": ["Brussels"],

            "Hainaut": ["Charleroi", "Mons"],

            "Liège": ["Liège"],

            "Luxembourg": ["Namur"],

            "Namur": ["Namur"],

            "Brussels-Capital Region": ["Brussels"]

        },

        "Spain": {

            "Andalusia": ["Seville", "Málaga", "Córdoba"],

            "Aragon": ["Zaragoza"],

            "Asturias": ["Asturias"],

            "Balearic Islands": ["Palma"],

            "Basque Country": ["Bilbao"],

            "Canary Islands": ["Canary Islands"],

            "Cantabria": ["Cantabria"],

            "Castile and León": ["Valladolid"],

            "Castile-La Mancha": ["Castile-La Mancha"],

            "Catalonia": ["Barcelona"],

            "Extremadura": ["Extremadura"],

            "Galicia": ["Galicia"],

            "La Rioja": ["La Rioja"],

            "Community of Madrid": ["Madrid"],

            "Region of Murcia": ["Murcia"],

            "Navarre": ["Navarre"],

            "Valencian Community": ["Valencia", "Alicante"]

        },

        "Macau": {

            "Macau SAR": ["Macau Peninsula", "Taipa", "Coloane", "Cotai"]

        },

        "Jordan": {

            "Amman": ["Amman"],

            "Irbid": ["Irbid"],

            "Zarqa": ["Zarqa", "Russeifa"],

            "Balqa": ["Salt"],

            "Madaba": ["Madaba"],

            "Karak": ["Karak"],

            "Tafilah": ["Tafila"],

            "Ma'an": ["Ma'an"],

            "Aqaba": ["Aqaba"],

            "Mafraq": ["Mafraq"],

            "Jerash": ["Jerash"],

            "Ajloun": ["Ajloun"]

        },

        "Malta": {

            "Northern Region": ["Mosta", "Naxxar", "St. Julian's", "Sliema"],

            "Southern Region": ["Valletta (Capital)", "Qormi", "Marsa", "Hamrun"],

            "South Eastern Region": ["Zabbar", "Marsaskala", "Fgura"],

            "Western Region": ["Rabat", "Mdina", "Birkirkara"],

            "Gozo Region": ["Victoria (Gozo)"]

        },

        "Iraq": {

            "Baghdad": ["Baghdad"],

            "Basra": ["Basra"],

            "Nineveh": ["Mosul"],

            "Erbil": ["Erbil"],

            "Sulaymaniyah": ["Sulaymaniyah"],

            "Duhok": ["Duhok"],

            "Anbar": ["Ramadi", "Fallujah"],

            "Babil": ["Hilla"],

            "Karbala": ["Karbala"],

            "Najaf": ["Najaf"],

            "Wasit": ["Kut"],

            "Diyala": ["Baqubah"],

            "Kirkuk": ["Kirkuk"],

            "Salah al-Din": ["Samarra"],

            "Maysan": ["Amarah"],

            "Dhi Qar": ["Nasiriyah"],

            "Al-Qadisiyyah": ["Al Diwaniyah"],

            "Muthanna": ["Samawah"]

        },

        "Luxembourg": {

            "Luxembourg": ["Luxembourg City (Capital)", "Strassen", "Bertrange"],

            "Esch-sur-Alzette": ["Esch-sur-Alzette", "Differdange", "Dudelange"],

            "Diekirch": ["Diekirch", "Ettelbruck"],

            "Capellen": ["Capellen"],

            "Grevenmacher": ["Grevenmacher"],

            "Mersch": ["Mersch"],

            "Redange": ["Redange"],

            "Remich": ["Remich"],

            "Clervaux": ["Clervaux"],

            "Echternach": ["Echternach"],

            "Vianden": ["Vianden"],

            "Wiltz": ["Wiltz"]

        }

    };



    // Get available countries for dropdown

    const availableCountries = Object.keys(countryStateCityData);



    // Get available states based on selected country

    const getAvailableStates = () => {

        if (!formData.country || !countryStateCityData[formData.country]) {

            return [];

        }

        return Object.keys(countryStateCityData[formData.country]);

    };



    // Get available cities based on selected country and state

    const getAvailableCities = () => {

        if (!formData.country || !formData.state_or_province || !countryStateCityData[formData.country]) {

            return [];

        }

        return countryStateCityData[formData.country][formData.state_or_province] || [];

    };



    // State for handling country dropdown

    const [showCountryDropdown, setShowCountryDropdown] = useState(false);

    const [visibleCountries, setVisibleCountries] = useState([]);

    const [remainingCountries, setRemainingCountries] = useState([]);



    useEffect(() => {

        window.scrollTo(0, 0);



        // Initialize visible countries (first 8 countries = 2 rows of 4)

        if (selectedExperience === "Fresher") {

            setVisibleCountries(fresherCountries.slice(0, 8));

            setRemainingCountries(fresherCountries.slice(8));

        } else if (selectedExperience === "Ex-Abroad" || selectedExperience === "Any") {

            setVisibleCountries(experiencedCountries.slice(0, 8));

            setRemainingCountries(experiencedCountries.slice(8));

        }

    }, [selectedExperience]);



    // Update visible countries when experience changes

    useEffect(() => {

        if (selectedExperience === "Fresher") {

            setVisibleCountries(fresherCountries.slice(0, 8));

            setRemainingCountries(fresherCountries.slice(8));

        } else if (selectedExperience === "Ex-Abroad" || selectedExperience === "Any") {

            setVisibleCountries(experiencedCountries.slice(0, 8));

            setRemainingCountries(experiencedCountries.slice(8));

        }

    }, [selectedExperience]);



    // Helper function to calculate timeline from date - MATCHING EXACTLY what timeline selection creates

    const calculateTimelineFromDate = (dateStr) => {

        if (!dateStr || dateStr === 'Immediate') return 'Immediate';



        try {

            const startDate = new Date(dateStr);

            const today = new Date();



            // Set both dates to start of day for accurate comparison

            today.setHours(0, 0, 0, 0);

            startDate.setHours(0, 0, 0, 0);



            const diffTime = startDate.getTime() - today.getTime();

            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));



            if (diffDays <= 0) return 'Immediate';



            // Create dates based on timeline selections to compare

            const oneWeekLater = new Date(today);

            oneWeekLater.setDate(today.getDate() + 7);



            const oneMonthLater = new Date(today);

            oneMonthLater.setMonth(today.getMonth() + 1);



            const twoMonthLater = new Date(today);

            twoMonthLater.setMonth(today.getMonth() + 2);



            const threeMonthLater = new Date(today);

            threeMonthLater.setMonth(today.getMonth() + 3);



            // Compare dates directly instead of days

            // This ensures that a date created by selecting "1 month" will match back to "1 month"

            if (startDate <= oneWeekLater) return '1 week';

            if (startDate <= oneMonthLater) return '1 month';

            if (startDate <= twoMonthLater) return '2 month';

            return '3 month';

        } catch (e) {

            console.error('Error calculating timeline:', e);

            return 'Immediate';

        }

    };



    useEffect(() => {

        if (isEditing && existingJobData) {

            const parsedCountries = parseCountries(existingJobData.candidates_country_experience);



            let jobStartingDate = '';

            let selectedDateValue = null;

            let timeline = 'Immediate';



            // First, check if there's a saved timeline preference

            if (existingJobData.job_starting_date === 'Immediate') {

                jobStartingDate = 'Immediate';

                timeline = 'Immediate';

            } else if (existingJobData.job_starting_date) {

                // Store the date as is

                jobStartingDate = existingJobData.job_starting_date;



                // Try to parse the date

                try {

                    // Try different date formats

                    if (existingJobData.job_starting_date.includes('T')) {

                        selectedDateValue = new Date(existingJobData.job_starting_date);

                    } else if (/^\d{4}-\d{2}-\d{2}$/.test(existingJobData.job_starting_date)) {

                        // Handle YYYY-MM-DD format

                        selectedDateValue = new Date(existingJobData.job_starting_date + 'T00:00:00');

                    } else if (/^\d{2}-\d{2}-\d{4}$/.test(existingJobData.job_starting_date)) {

                        // Handle DD-MM-YYYY format

                        const [day, month, year] = existingJobData.job_starting_date.split('-');

                        selectedDateValue = new Date(year, month - 1, day);

                    } else {

                        // Try direct parsing

                        selectedDateValue = new Date(existingJobData.job_starting_date);

                    }



                    // Ensure date is valid

                    if (isNaN(selectedDateValue.getTime())) {

                        selectedDateValue = null;

                        jobStartingDate = 'Immediate';

                        timeline = 'Immediate';

                    } else {

                        // Calculate timeline from the date

                        timeline = calculateTimelineFromDate(existingJobData.job_starting_date);

                    }

                } catch (e) {

                    console.error('Error parsing date:', e);

                    jobStartingDate = 'Immediate';

                    timeline = 'Immediate';

                }

            }



            // Determine category based on saved position

            let category = 'Domestic Helper';

            if (hospitalJobPositions.find(pos => pos.position === existingJobData.domestic_worker_category) || hospitalJobPositions.includes(existingJobData.domestic_worker_category)) {

                category = 'Hospital';

            } else if (isHospitalityPosition(existingJobData.domestic_worker_category)) {

                category = HOSPITALITY_CATEGORY;

            } else if (isSoftwareItPosition(existingJobData.domestic_worker_category)) {

                category = SOFTWARE_IT_CATEGORY;

            } else if (isConstructionPosition(existingJobData.domestic_worker_category)) {

                category = CONSTRUCTION_CATEGORY;

            } else if (isRetailSalesPosition(existingJobData.domestic_worker_category)) {

                category = RETAIL_SALES_CATEGORY;

            } else if (isCleaningMaintenancePosition(existingJobData.domestic_worker_category)) {

                category = CLEANING_MAINTENANCE_CATEGORY;

            } else if (companyWorkerPositions.find(pos => pos.position === existingJobData.domestic_worker_category) || companyWorkerPositions.includes(existingJobData.domestic_worker_category)) {

                category = 'Company Worker';

            }



            setFormData({

                ...existingJobData,

                candidates_country_experience: parsedCountries,

                job_starting_date: jobStartingDate,

                country: existingJobData.country || '',

                state_or_province: existingJobData.state_or_province || '',

                working_city: existingJobData.working_city || ''

            });



            setSelectedCategory(category);

            setSelectedJobType(existingJobData.job_type || 'Full Time');

            setSelectedExperience(existingJobData.candidate_experience || '');

            setSelectedCountries(parsedCountries);

            setGulfExperience(existingJobData.gulf_experience_years || 0);

            setTotalExperience(existingJobData.total_experience_years || 0);

            setJobStartingTimeline(timeline);

            setSelectedDate(selectedDateValue);

            setIsSaved(true);

        } else if (userId) {

            fetchEmployerData();

        }

    }, [userId, temporaryId, isEditing, existingJobData]);



    const parseCountries = (countriesString) => {

        if (!countriesString) return [];

        try {

            const parsed = JSON.parse(countriesString);

            if (typeof parsed === 'string') {

                const secondParse = JSON.parse(parsed);

                if (typeof secondParse === 'string') {

                    return JSON.parse(secondParse);

                }

                return secondParse;

            }

            return parsed;

        } catch (e) {

            console.error('Error parsing countries:', e);

            return [];

        }

    };



    const fetchEmployerData = async () => {

        try {

            const response = await fetch(`${BaseUrl}/api/employer?temporary_id=${temporaryId}&user_id=${userId}`);

            if (response.ok) {

                const data = await response.json();

                if (data) {

                    const parsedCountries = parseCountries(data.candidates_country_experience);



                    let jobStartingDate = '';

                    let selectedDateValue = null;

                    let timeline = 'Immediate';



                    if (data.job_starting_date && data.job_starting_date !== 'Immediate') {

                        // Store the date as is

                        jobStartingDate = data.job_starting_date;



                        // Try to parse the date

                        try {

                            if (data.job_starting_date.includes('T')) {

                                selectedDateValue = new Date(data.job_starting_date);

                            } else if (/^\d{4}-\d{2}-\d{2}$/.test(data.job_starting_date)) {

                                // Handle YYYY-MM-DD format

                                selectedDateValue = new Date(data.job_starting_date + 'T00:00:00');

                            } else if (/^\d{2}-\d{2}-\d{4}$/.test(data.job_starting_date)) {

                                const [day, month, year] = data.job_starting_date.split('-');

                                selectedDateValue = new Date(year, month - 1, day);

                            } else {

                                selectedDateValue = new Date(data.job_starting_date);

                            }



                            // Ensure date is valid

                            if (isNaN(selectedDateValue.getTime())) {

                                selectedDateValue = null;

                                jobStartingDate = 'Immediate';

                                timeline = 'Immediate';

                            } else {

                                // Calculate timeline from the date using the new function

                                timeline = calculateTimelineFromDate(data.job_starting_date);

                            }

                        } catch (e) {

                            console.error('Error parsing date:', e);

                            jobStartingDate = 'Immediate';

                            timeline = 'Immediate';

                        }

                    } else if (data.job_starting_date === 'Immediate') {

                        jobStartingDate = 'Immediate';

                        timeline = 'Immediate';

                    }



                    // Determine category based on saved position

                    let category = 'Domestic Helper';

                    if (hospitalJobPositions.find(pos => pos.position === data.domestic_worker_category) || hospitalJobPositions.includes(data.domestic_worker_category)) {

                        category = 'Hospital';

                    } else if (isHospitalityPosition(data.domestic_worker_category)) {

                        category = HOSPITALITY_CATEGORY;

                    } else if (isSoftwareItPosition(data.domestic_worker_category)) {

                        category = SOFTWARE_IT_CATEGORY;

                    } else if (isConstructionPosition(data.domestic_worker_category)) {

                        category = CONSTRUCTION_CATEGORY;

                    } else if (isRetailSalesPosition(data.domestic_worker_category)) {

                        category = RETAIL_SALES_CATEGORY;

                    } else if (isCleaningMaintenancePosition(data.domestic_worker_category)) {

                        category = CLEANING_MAINTENANCE_CATEGORY;

                    } else if (companyWorkerPositions.find(pos => pos.position === data.domestic_worker_category) || companyWorkerPositions.includes(data.domestic_worker_category)) {

                        category = 'Company Worker';

                    }



                    setFormData(prev => ({

                        ...prev,

                        ...data,

                        candidates_country_experience: parsedCountries,

                        job_starting_date: jobStartingDate,

                        customCountryInput: '',

                        country: data.country || '',

                        state_or_province: data.state_or_province || '',

                        working_city: data.working_city || ''

                    }));



                    setSelectedCategory(category);

                    setSelectedJobType(data.job_type || 'Full Time');

                    setSelectedExperience(data.candidate_experience || '');

                    setSelectedCountries(parsedCountries);

                    setGulfExperience(data.gulf_experience_years || 0);

                    setTotalExperience(data.total_experience_years || 0);

                    setJobStartingTimeline(timeline);

                    setSelectedDate(selectedDateValue);

                    setIsSaved(true);

                }

            }

        } catch (error) {

            console.error('Error fetching employer data:', error);

        }

    };



    const handleInputChange = (e) => {

        const { name, value } = e.target;

        setFormData(prev => ({

            ...prev,

            [name]: value

        }));

        setIsSaved(false);

    };



    // Handle country change - reset state and city when country changes

    const handleCountryChange = (country) => {

        setFormData(prev => ({

            ...prev,

            country: country,

            state_or_province: '', // Reset state when country changes

            working_city: '' // Reset city when country changes

        }));



        // Auto-fill Macau SAR when Macau is selected

        if (country === 'Macau') {

            setFormData(prev => ({

                ...prev,

                state_or_province: 'Macau SAR'

            }));

            console.log(`Auto-filled state_or_province to Macau SAR for Macau`);

        }

        setIsSaved(false);

    };



    // Handle state change - reset city when state changes

    const handleStateChange = (state) => {

        setFormData(prev => ({

            ...prev,

            state_or_province: state,

            working_city: '' // Reset city when state changes

        }));

        setIsSaved(false);

    };



    // Handle city change

    const handleCityChange = (city) => {

        setFormData(prev => ({

            ...prev,

            working_city: city

        }));

        setIsSaved(false);

    };



    const handleJobTypeSelect = (type) => {

        if (type === 'Part Time') {

            setPendingJobType(type);

            setShowPartTimeModal(true);

        } else {

            setSelectedJobType(type);

            setFormData(prev => ({

                ...prev,

                job_type: type

            }));

            setIsSaved(false);

        }

    };



    const handlePartTimeAgreement = () => {

        if (partTimeAgreed) {

            setSelectedJobType('Part Time');

            setFormData(prev => ({

                ...prev,

                job_type: 'Part Time'

            }));

            setShowPartTimeModal(false);

            setPartTimeAgreed(false);

            setIsSaved(false);

        } else {

            Swal.fire('Error', 'You must agree to follow labor laws to select Part Time job type', 'error');

        }

    };



    const handleCancelPartTime = () => {

        setShowPartTimeModal(false);

        setPartTimeAgreed(false);

        setPendingJobType(null);

        if (selectedJobType === 'Part Time') {

            setSelectedJobType('Full Time');

            setFormData(prev => ({

                ...prev,

                job_type: 'Full Time'

            }));

        }

    };



    const handleInfoClick = () => {

        Swal.fire({

            title: 'Job Type Information',

            text: 'Follow labor laws. Part-time jobs are for permanent residents only.',

            icon: 'info',

            confirmButtonText: 'OK',

            customClass: {

                popup: 'custom-swal-popup'

            }

        });

    };



    const handleExperienceSelect = (type) => {

        setSelectedExperience(type);

        setFormData(prev => ({

            ...prev,

            candidate_experience: type

        }));



        if (type === "Fresher") {

            setSelectedCountries([]);

            setFormData(prev => ({

                ...prev,

                candidates_country_experience: []

            }));

            // Set visible countries for fresher

            setVisibleCountries(fresherCountries.slice(0, 8));

            setRemainingCountries(fresherCountries.slice(8));

        } else {

            // Set visible countries for experienced

            setVisibleCountries(experiencedCountries.slice(0, 8));

            setRemainingCountries(experiencedCountries.slice(8));

        }

        setIsSaved(false);

    };



    const handleCountrySelect = (country) => {

        let updatedCountries;

        if (selectedCountries.includes(country)) {

            updatedCountries = selectedCountries.filter(c => c !== country);

        } else {

            updatedCountries = [...selectedCountries, country];

        }

        setSelectedCountries(updatedCountries);

        setFormData(prev => ({

            ...prev,

            candidates_country_experience: updatedCountries

        }));

        setIsSaved(false);

    };



    const handleAddCustomCountry = () => {

        if (formData.customCountryInput && formData.customCountryInput.trim() !== '') {

            const customCountry = formData.customCountryInput.trim();

            const currentCountryList = selectedExperience === "Fresher" ? fresherCountries : experiencedCountries;



            const isPredefinedCountry = currentCountryList.includes(customCountry);



            if (!isPredefinedCountry) {

                let updatedCountries;

                if (selectedCountries.includes(customCountry)) {

                    updatedCountries = selectedCountries.filter(c => c !== customCountry);

                } else {

                    updatedCountries = [...selectedCountries, customCountry];

                }

                setSelectedCountries(updatedCountries);

                setFormData(prev => ({

                    ...prev,

                    candidates_country_experience: updatedCountries,

                    customCountryInput: ''

                }));

                setIsSaved(false);

                Swal.fire('Success', `"${customCountry}" added to selected countries`, 'success');

            } else {

                handleCountrySelect(customCountry);

                setFormData(prev => ({

                    ...prev,

                    customCountryInput: ''

                }));

            }

        }

    };



    const handleDateChange = (date) => {

        setSelectedDate(date);

        if (date) {

            // Ensure date is valid

            if (isNaN(date.getTime())) {

                // If invalid date, set to Immediate

                setFormData(prev => ({

                    ...prev,

                    job_starting_date: 'Immediate'

                }));

                setJobStartingTimeline('Immediate');

            } else {

                // Format date as YYYY-MM-DD

                const year = date.getFullYear();

                const month = String(date.getMonth() + 1).padStart(2, '0');

                const day = String(date.getDate()).padStart(2, '0');

                const formattedDate = `${year}-${month}-${day}`;



                setFormData(prev => ({

                    ...prev,

                    job_starting_date: formattedDate

                }));



                // Auto-select timeline based on date using improved calculation

                const timeline = calculateTimelineFromDate(formattedDate);

                setJobStartingTimeline(timeline);

            }

        } else {

            // If date is cleared, set to Immediate

            setFormData(prev => ({

                ...prev,

                job_starting_date: 'Immediate'

            }));

            setJobStartingTimeline('Immediate');

        }

        setIsSaved(false);

    };



    const handleTimelineSelect = (timeline) => {

        // Convert "Immediate" to "Immediate" for internal storage

        const internalTimeline = timeline === 'Immediate' ? 'Immediate' : timeline;



        setJobStartingTimeline(internalTimeline);



        if (internalTimeline === 'Immediate') {

            // For "Immediate", store the string "Immediate"

            setFormData(prev => ({

                ...prev,

                job_starting_date: 'Immediate'

            }));

            setSelectedDate(null);

        } else {

            // For other timelines, calculate and set the date

            const today = new Date();

            let startDate = new Date(today);



            // Set time to start of day

            startDate.setHours(0, 0, 0, 0);



            switch (internalTimeline) {

                case '1 week':

                    startDate.setDate(today.getDate() + 7);

                    break;

                case '1 month':

                    // Add exactly 1 month

                    startDate.setMonth(today.getMonth() + 1);

                    // Ensure we don't go to the next month if day doesn't exist

                    if (startDate.getDate() !== today.getDate()) {

                        // If day doesn't exist in next month, go to last day of month

                        startDate.setDate(0);

                    }

                    break;

                case '2 month':

                    // Add exactly 2 months

                    startDate.setMonth(today.getMonth() + 2);

                    if (startDate.getDate() !== today.getDate()) {

                        startDate.setDate(0);

                    }

                    break;

                case '3 month':

                    // Add exactly 3 months

                    startDate.setMonth(today.getMonth() + 3);

                    if (startDate.getDate() !== today.getDate()) {

                        startDate.setDate(0);

                    }

                    break;

                default:

                    break;

            }



            setSelectedDate(startDate);



            const year = startDate.getFullYear();

            const month = String(startDate.getMonth() + 1).padStart(2, '0');

            const day = String(startDate.getDate()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day}`;



            setFormData(prev => ({

                ...prev,

                job_starting_date: formattedDate

            }));

        }

        setIsSaved(false);

    };



    const validateFormData = async () => {

        const requiredFields = [

            { field: 'domestic_worker_category', name: 'Job Offer' },

            { field: 'job_type', name: 'Job Type' },

            { field: 'candidate_experience', name: 'Candidate Experience' },

            { field: 'country', name: 'Country' },

            { field: 'job_starting_date', name: 'Job Starting Date' }

        ];



        // Special check for job_starting_date - allow "Immediate" or a date

        const isJobStartingDateValid = formData.job_starting_date &&

            (formData.job_starting_date === 'Immediate' ||

                /^\d{4}-\d{2}-\d{2}$/.test(formData.job_starting_date));



        if (!isJobStartingDateValid) {

            const result = await Swal.fire({

                title: 'Error!',

                text: 'Please select a valid job starting date or choose "Immediate"',

                icon: 'error',

                confirmButtonText: 'OK',

                confirmButtonColor: '#d33',

            });



            if (result.isConfirmed || result.isDismissed) {

                focusOnField('job_starting_date');

            }

            return false;

        }



        const missingFields = requiredFields.filter(item => {

            if (item.field === 'job_starting_date') {

                return !isJobStartingDateValid;

            }

            return !formData[item.field];

        });



        if (missingFields.length > 0) {

            const result = await Swal.fire({

                title: 'Error!',

                text: `Please fill in all required fields: ${missingFields.map(item => item.name).join(', ')}`,

                icon: 'error',

                confirmButtonText: 'OK',

                confirmButtonColor: '#d33',

            });



            if (result.isConfirmed || result.isDismissed) {

                const firstMissingField = missingFields[0];

                focusOnField(firstMissingField.field);

            }

            return false;

        }



        // Additional validations

        if (formData.country && formData.country.trim().length < 2) {

            const result = await Swal.fire({

                title: 'Error!',

                text: 'Please enter a valid country name',

                icon: 'error',

                confirmButtonText: 'OK',

                confirmButtonColor: '#d33',

            });



            if (result.isConfirmed || result.isDismissed) {

                focusOnField('country');

            }

            return false;

        }



        if (formData.state_or_province && formData.state_or_province.trim().length < 2) {

            const result = await Swal.fire({

                title: 'Error!',

                text: 'Please enter a valid state/province name',

                icon: 'error',

                confirmButtonText: 'OK',

                confirmButtonColor: '#d33',

            });



            if (result.isConfirmed || result.isDismissed) {

                focusOnField('state_or_province');

            }

            return false;

        }



        if (formData.working_city && formData.working_city.trim().length < 2) {

            const result = await Swal.fire({

                title: 'Error!',

                text: 'Please enter a valid city name',

                icon: 'error',

                confirmButtonText: 'OK',

                confirmButtonColor: '#d33',

            });



            if (result.isConfirmed || result.isDismissed) {

                focusOnField('working_city');

            }

            return false;

        }



        return true;

    };



    useEffect(() => {

        setFormData(prev => ({

            ...prev,

            gulf_experience_years: gulfExperience,

            total_experience_years: totalExperience

        }));

        setIsSaved(false);

    }, [gulfExperience, totalExperience]);



    // Focus function for validation errors

    const focusOnField = (fieldName) => {

        setTimeout(() => {

            let element = null;



            switch (fieldName) {

                case 'domestic_worker_category':

                    element = domesticWorkerCategoryRef.current;

                    break;

                case 'job_type':

                    element = jobTypeRef.current;

                    break;

                case 'candidate_experience':

                    element = candidateExperienceRef.current;

                    break;

                case 'country':

                    element = countryRef.current;

                    break;

                case 'job_starting_date':

                    element = jobStartingDateRef.current;

                    break;

                default:

                    break;

            }



            if (element) {

                element.scrollIntoView({ behavior: 'smooth', block: 'center' });



                setTimeout(() => {

                    if (element.focus) {

                        element.focus();

                        if (document.activeElement !== element) {

                            element.focus();

                        }

                    }

                }, 300);

            }

        }, 100);

    };



    const saveData = async () => {

        setIsLoading(true);



        Swal.fire({

            title: 'Saving...',

            allowOutsideClick: false,

            didOpen: () => {

                Swal.showLoading();

            }

        });



        try {

            const payload = {

                ...formData,

                candidates_country_experience: JSON.stringify(formData.candidates_country_experience)

            };



            const response = await fetch(`${BaseUrl}/api/employer`, {

                method: 'POST',

                headers: {

                    'Content-Type': 'application/json',

                },

                body: JSON.stringify(payload)

            });



            const data = await response.json();



            if (!response.ok) {

                throw new Error(data.message || 'Failed to save data');

            }



            // After saving, update the local state with the saved data

            if (data.id) {

                await fetchEmployerData();

            }



            await Swal.fire({

                title: 'Success!',

                text: 'Your basic information has been saved successfully.',

                icon: 'success',

                confirmButtonText: 'OK',

                confirmButtonColor: '#3085d6',

            });



            setIsSaved(true);

            return data;

        } catch (err) {

            console.error('Error saving data:', err);



            await Swal.fire({

                title: 'Error!',

                text: err.message || 'Failed to save data. Please try again.',

                icon: 'error',

                confirmButtonText: 'OK',

                confirmButtonColor: '#d33',

            });



            throw err;

        } finally {

            setIsLoading(false);

        }

    };



    const handleSave = async () => {

        const isValid = await validateFormData();

        if (!isValid) return;



        try {

            await saveData();

        } catch (err) {

            // Error already handled in saveData

        }

    };



    const handleNext = async () => {

        const isValid = await validateFormData();

        if (!isValid) return;



        try {

            await saveData();

            window.scrollTo(0, 0);

            navigate('/a-requiredskills', { state: { userId, temporaryId } });

        } catch (err) {

            // Error already handled in saveData

        }

    };



    // Custom Dropdown Component with Search with unique classname

    const CustomDropdown = ({

        title,

        field,

        options,

        selectedValue,

        onSelect,

        disabled = false,

        multiple = false

    }) => {

        const [localSearchTerm, setLocalSearchTerm] = useState('');

        const [isOpen, setIsOpen] = useState(false);



        const filterOptions = (options, searchTerm) => {

            if (!searchTerm) return options;

            return options.filter(option =>

                option.toString().toLowerCase().includes(searchTerm.toLowerCase())

            );

        };



        const filteredOptions = filterOptions(options, localSearchTerm);



        // Get display text for dropdown toggle

        const getDisplayText = () => {

            if (multiple) {

                if (selectedValue.length === 0) return title;

                if (selectedValue.length === 1) return selectedValue[0];

                if (selectedValue.length === 2) return `${selectedValue[0]}, ${selectedValue[1]}`;

                return `${selectedValue[0]}, ${selectedValue[1]}, +${selectedValue.length - 2} more`;

            }

            return selectedValue || title;

        };



        return (

            <Dropdown

                className="mb-3 custom-country-dropdown"

                show={isOpen}

                onToggle={(isOpen) => setIsOpen(isOpen)}

            >

                <Dropdown.Toggle

                    variant="light"

                    className="dropdown-btn w-100 d-flex justify-content-between align-items-center"

                    id={`dropdown-${field}`}

                    disabled={disabled}

                >

                    {getDisplayText()}

                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100 custom-country-dropdown-menu">

                    <div className="px-2 py-1">

                        <Form.Control

                            type="text"

                            placeholder={`Search ${title.toLowerCase()}...`}

                            value={localSearchTerm}

                            onChange={(e) => setLocalSearchTerm(e.target.value)}

                            onClick={(e) => e.stopPropagation()}

                            className="mb-2"

                            autoFocus

                        />

                    </div>

                    <div className="custom-country-dropdown-options" style={{ maxHeight: '250px', overflowY: 'auto' }}>

                        {filteredOptions.length > 0 ? (

                            filteredOptions.map((option) => (

                                <Dropdown.Item

                                    key={option}

                                    active={multiple ? selectedValue.includes(option) : selectedValue === option}

                                    onClick={() => {

                                        if (multiple) {

                                            let updatedValues;

                                            if (selectedValue.includes(option)) {

                                                updatedValues = selectedValue.filter(item => item !== option);

                                            } else {

                                                updatedValues = [...selectedValue, option];

                                            }

                                            onSelect(updatedValues);

                                        } else {

                                            onSelect(option);

                                            setLocalSearchTerm('');

                                            setIsOpen(false);

                                        }

                                    }}

                                >

                                    {option}

                                    {multiple && selectedValue.includes(option) && (
                                        <span className="float-end">✓</span>
                                    )}

                                </Dropdown.Item>

                            ))

                        ) : (

                            <Dropdown.Item disabled>No matches found</Dropdown.Item>

                        )}

                    </div>

                </Dropdown.Menu>

            </Dropdown>

        );

    };



    const InfoTooltip = (props) => (

        <Tooltip id="job-type-tooltip" {...props}>

            Follow labor laws. Part-time jobs are for permanent residents only.

        </Tooltip>

    );



    const renderCountryButtons = () => {

        const title = selectedExperience === "Fresher"

            ? "Select the workers nationality"

            : "Candidate Country Experience - Select";



        const allWorldCountries = [

            "Any Country",

            "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",

            "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",

            "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",

            "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad",

            "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",

            "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor",

            "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji",

            "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala",

            "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia",

            "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan",

            "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",

            "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",

            "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia",

            "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand",

            "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",

            "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",

            "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines",

            "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",

            "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan",

            "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",

            "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda",

            "Ukraine", "UAE", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu",

            "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"

        ];



        return (

            <div>

                <h4 className="mb-3 basicinfo-basicinfo">{title}</h4>



                <CustomDropdown

                    title="Select Countries"

                    field="candidates_country_experience"

                    options={allWorldCountries}

                    selectedValue={selectedCountries}

                    onSelect={(selected) => {

                        setSelectedCountries(selected);

                        setFormData(prev => ({

                            ...prev,

                            candidates_country_experience: selected

                        }));

                        setIsSaved(false);

                    }}

                    multiple={true}

                />

            </div>

        );

    };



    return (

        <>

            <AgencyNavbar />

            <Container fluid className="job-form py-4" style={{ marginTop: '70px' }}>

                <div className="form-header text-center">

                    <h4 className="basic-info-title d-flex align-items-center justify-content-center">

                        <i className="bi bi-person-vcard me-2" ></i>

                        Basic information

                    </h4>

                </div>



                {/* Category Section - MODIFIED WITH IMAGES */}

                <div className="section mt-3">

                    <h4 className="d-flex align-items-center basicinfo-basicinfo">

                        <span style={{ color: 'black' }}>Select Category<span className="text-danger">*</span></span>

                    </h4>



                    <CustomDropdown

                        title="Select Category"

                        field="selected_category"

                        options={EMPLOYER_CATEGORY_OPTIONS}

                        selectedValue={selectedCategory === 'Hospital' ? 'Healthcare' : selectedCategory}

                        onSelect={(val) => {

                            const actualCategory = val === 'Healthcare' ? 'Hospital' : val;

                            setSelectedCategory(actualCategory);



                            // Reset default position when switching categories

                            if (actualCategory === 'Domestic Helper') {

                                if (hospitalJobPositions.includes(formData.domestic_worker_category) ||

                                    companyWorkerPositions.includes(formData.domestic_worker_category) ||

                                    hospitalityJobPositions.includes(formData.domestic_worker_category) ||

                                    softwareItJobPositions.includes(formData.domestic_worker_category) ||

                                    constructionJobPositions.includes(formData.domestic_worker_category) ||

                                    retailSalesJobPositions.includes(formData.domestic_worker_category) ||

                                    cleaningMaintenanceJobPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: 'Domestic Helper'

                                    }));

                                }

                            } else if (actualCategory === 'Hospital') {

                                if (jobPositions.includes(formData.domestic_worker_category) ||

                                    companyWorkerPositions.includes(formData.domestic_worker_category) ||

                                    hospitalityJobPositions.includes(formData.domestic_worker_category) ||

                                    softwareItJobPositions.includes(formData.domestic_worker_category) ||

                                    constructionJobPositions.includes(formData.domestic_worker_category) ||

                                    retailSalesJobPositions.includes(formData.domestic_worker_category) ||

                                    cleaningMaintenanceJobPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: 'House Nurse'

                                    }));

                                }

                            } else if (actualCategory === HOSPITALITY_CATEGORY) {

                                if (jobPositions.includes(formData.domestic_worker_category) ||

                                    hospitalJobPositions.includes(formData.domestic_worker_category) ||

                                    companyWorkerPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: hospitalityJobPositions[0]

                                    }));

                                }

                            } else if (actualCategory === SOFTWARE_IT_CATEGORY) {

                                if (jobPositions.includes(formData.domestic_worker_category) ||

                                    hospitalJobPositions.includes(formData.domestic_worker_category) ||

                                    companyWorkerPositions.includes(formData.domestic_worker_category) ||

                                    hospitalityJobPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: softwareItJobPositions[0]

                                    }));

                                }

                            } else if (actualCategory === CONSTRUCTION_CATEGORY) {

                                if (jobPositions.includes(formData.domestic_worker_category) ||

                                    hospitalJobPositions.includes(formData.domestic_worker_category) ||

                                    companyWorkerPositions.includes(formData.domestic_worker_category) ||

                                    hospitalityJobPositions.includes(formData.domestic_worker_category) ||

                                    softwareItJobPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: constructionJobPositions[0]

                                    }));

                                }

                            } else if (actualCategory === RETAIL_SALES_CATEGORY) {

                                if (jobPositions.includes(formData.domestic_worker_category) ||

                                    hospitalJobPositions.includes(formData.domestic_worker_category) ||

                                    companyWorkerPositions.includes(formData.domestic_worker_category) ||

                                    hospitalityJobPositions.includes(formData.domestic_worker_category) ||

                                    softwareItJobPositions.includes(formData.domestic_worker_category) ||

                                    constructionJobPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: retailSalesJobPositions[0]

                                    }));

                                }

                            } else if (actualCategory === CLEANING_MAINTENANCE_CATEGORY) {

                                if (jobPositions.includes(formData.domestic_worker_category) ||

                                    hospitalJobPositions.includes(formData.domestic_worker_category) ||

                                    companyWorkerPositions.includes(formData.domestic_worker_category) ||

                                    hospitalityJobPositions.includes(formData.domestic_worker_category) ||

                                    softwareItJobPositions.includes(formData.domestic_worker_category) ||

                                    constructionJobPositions.includes(formData.domestic_worker_category) ||

                                    retailSalesJobPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: cleaningMaintenanceJobPositions[0]

                                    }));

                                }

                            } else if (actualCategory === 'Company Worker') {

                                if (jobPositions.includes(formData.domestic_worker_category) ||

                                    hospitalJobPositions.includes(formData.domestic_worker_category) ||

                                    hospitalityJobPositions.includes(formData.domestic_worker_category) ||

                                    softwareItJobPositions.includes(formData.domestic_worker_category) ||

                                    constructionJobPositions.includes(formData.domestic_worker_category) ||

                                    retailSalesJobPositions.includes(formData.domestic_worker_category) ||

                                    cleaningMaintenanceJobPositions.includes(formData.domestic_worker_category)) {

                                    setFormData(prev => ({

                                        ...prev,

                                        domestic_worker_category: 'Workers'

                                    }));

                                }

                            }

                            setIsSaved(false);

                        }}

                    />

                </div>



                {/* Job Offer 2 Section - WITHOUT IMAGES */}

                <div className="section mt-3" ref={domesticWorkerCategoryRef}>

                    <h4 className="d-flex align-items-center basicinfo-basicinfo">

                        <span style={{ color: 'black' }}>Job Offer<span className="text-danger">*</span></span>

                    </h4>



                    {/* Show different dropdown based on category */}

                    <CustomDropdown

                        title={selectedCategory === 'Hospital' ? "Select Hospital Position" : "Select Job Position"}

                        field="domestic_worker_category"

                        options={getFilteredJobPositions()}

                        selectedValue={formData.domestic_worker_category}

                        onSelect={(value) => {

                            setFormData(prev => ({

                                ...prev,

                                domestic_worker_category: value

                            }));

                            setIsSaved(false);

                        }}

                    />

                </div>



                {/* Job Type Section - Mobile optimized layout with 2-button grid */}

                <div className="section mt-4" ref={jobTypeRef}>

                    <h4 className="d-flex align-items-center basicinfo-basicinfo">

                        <span style={{ color: 'black' }}>

                            Job Type

                            <span className="text-danger">*</span>

                        </span>

                        <OverlayTrigger

                            placement="top"

                            overlay={InfoTooltip}

                            show={showInfoTooltip}

                            onToggle={setShowInfoTooltip}

                        >

                            <Button

                                variant="link"

                                className="p-0 ms-2"

                                style={{

                                    border: 'none',

                                    background: 'none',

                                    color: '#6c757d'

                                }}

                                onClick={handleInfoClick}

                            >

                                <FaInfoCircle size={20} />

                            </Button>

                        </OverlayTrigger>

                    </h4>

                    <Row className="g-3 mb-3 job-type-mobile-row">

                        {["Full Time", "Part Time"].map((type, idx) => (

                            <Col xs={6} sm={6} md={6} key={idx} className="job-type-col-mobile">

                                <Button

                                    variant={selectedJobType === type ? "primary" : "outline-primary"}

                                    className={`language-btn w-100 job-type-btn ${selectedJobType === type ? 'selected' : ''}`}

                                    onClick={() => handleJobTypeSelect(type)}

                                >

                                    <span className="job-type-text">

                                        {type}

                                    </span>

                                    {selectedJobType === type && (

                                        <i className="bi bi-check-circle-fill ms-2"></i>

                                    )}

                                </Button>

                            </Col>

                        ))}

                    </Row>



                    {selectedJobType === 'Part Time' && (

                        <div className="mt-3 alert alert-warning small" style={{ fontSize: '20px' }}>

                            <strong>You must follow labor laws.</strong> Part-time jobs are for permanent residents only and must comply with local labor regulations.

                        </div>

                    )}



                    {selectedJobType !== 'Part Time' && (

                        <div className="mt-3 small" style={{ fontSize: '20px' }}>



                        </div>

                    )}

                </div>



                {/* Candidate Experience Section */}

                <div className="section mt-4" ref={candidateExperienceRef}>

                    <h4 className="d-flex align-items-center basicinfo-basicinfo">

                        <span className="" style={{ color: 'black' }}>Candidate Experience - Select<span className="text-danger">*</span></span>

                    </h4>



                    <CustomDropdown

                        title="Select Candidate Experience"

                        field="candidate_experience"

                        options={["Fresher", "Ex-Gulf", "Ex-Europe", "Ex-Abroad", "Any country"]}

                        selectedValue={formData.candidate_experience}

                        onSelect={handleExperienceSelect}

                    />



                    {selectedExperience !== "Fresher" && (

                        <>

                            <div className="mb-5 gilf-exp">

                                <h4>

                                    Gulf Experience

                                </h4>

                                <div className="mt-3">

                                    <Form.Select

                                        value={gulfExperience}

                                        onChange={(e) => setGulfExperience(parseInt(e.target.value, 10))}

                                        className="dropdown-btn w-100"

                                        style={{ height: '60px', fontSize: '20px' }}

                                    >

                                        {Array.from({ length: 41 }, (_, i) => (

                                            <option key={i} value={i}>

                                                {i} years

                                            </option>

                                        ))}

                                    </Form.Select>

                                </div>

                                <div className="text-center mt-2">

                                    Selected: {gulfExperience} years

                                </div>

                            </div>



                            <div className='total-exp mb-4'>

                                <h4>

                                    Total Experience

                                </h4>

                                <div className="mt-3">

                                    <Form.Select

                                        value={totalExperience}

                                        onChange={(e) => setTotalExperience(parseInt(e.target.value, 10))}

                                        className="dropdown-btn w-100"

                                        style={{ height: '60px', fontSize: '20px' }}

                                    >

                                        {Array.from({ length: 41 }, (_, i) => (

                                            <option key={i} value={i}>

                                                {i} years

                                            </option>

                                        ))}

                                    </Form.Select>

                                </div>

                                <div className="text-center mt-2">

                                    Selected: {totalExperience} years

                                </div>

                            </div>

                        </>

                    )}



                    {/* Render country selection based on experience */}

                    {renderCountryButtons()}



                    <h4 className="mt-4">

                        <span className="mb-3 basicinfo-basicinfo">Country Of Work <span className="text-danger">*</span></span>

                    </h4>



                    <CustomDropdown

                        className="country-work-dropdown"

                        title="Select Country where candidate will work"

                        field="country"

                        options={availableCountries}

                        selectedValue={formData.country}

                        onSelect={handleCountryChange}

                    />



                    <div className="mt-3">

                        <Form.Group>

                            <div className="d-flex gap-2">

                                <Form.Control

                                    ref={countryRef}

                                    type="text"

                                    placeholder="Your Country not listed? Type here"

                                    className="flex-grow-1"

                                    name="country"

                                    value={formData.country}

                                    onChange={handleInputChange}

                                    style={{ height: '60px', fontSize: '18px', backgroundColor: '#aec9f3', borderRadius: '0px' }}

                                />

                            </div>

                        </Form.Group>

                    </div>



                    <h4 className="mt-4">

                        <span className="mb-3 basicinfo-basicinfo" >State/Province of work<span className="text-danger"></span></span>

                    </h4>



                    <CustomDropdown

                        title="Select State/Province where candidate will work"

                        field="state_or_province"

                        options={getAvailableStates()}

                        selectedValue={formData.state_or_province}

                        onSelect={handleStateChange}

                        disabled={!formData.country}

                    />



                    <div className="mt-3">

                        <Form.Group>

                            <div className="d-flex gap-2">

                                <Form.Control

                                    ref={stateRef}

                                    type="text"

                                    placeholder="Your state/province not listed? Type here"

                                    className="flex-grow-1"

                                    name="state_or_province"

                                    value={formData.state_or_province}

                                    onChange={handleInputChange}

                                    style={{ height: '60px', fontSize: '18px', backgroundColor: '#aec9f3', borderRadius: '0px' }}

                                />

                            </div>

                        </Form.Group>

                    </div>



                    <h4 className="mt-4">

                        <span className="mb-3 basicinfo-basicinfo" >City of work

                        </span>

                    </h4>



                    <CustomDropdown

                        title="Select City/Work Area where candidate will work"

                        field="working_city"

                        options={getAvailableCities()}

                        selectedValue={formData.working_city}

                        onSelect={handleCityChange}

                        disabled={!formData.state_or_province}

                    />



                    <div className="mt-3">

                        <Form.Group>

                            <div className="d-flex gap-2">

                                <Form.Control

                                    ref={cityRef}

                                    type="text"

                                    placeholder="Your City/Work not listed? Type here"

                                    className="flex-grow-1"

                                    name="working_city"

                                    value={formData.working_city}

                                    onChange={handleInputChange}

                                    style={{ height: '60px', fontSize: '18px', backgroundColor: '#aec9f3', borderRadius: '0px' }}

                                />

                            </div>

                        </Form.Group>

                    </div>



                    <h4 className="mt-4">

                        <span className="mb-3 basicinfo-basicinfo">Job starting date<span className="text-danger">*</span></span>

                    </h4>



                    {/* FIXED: Always show DatePicker when there's a date selected */}

                    {formData.job_starting_date && formData.job_starting_date !== 'Immediate' && (

                        <div className="mb-3 w-100">

                            <DatePicker

                                ref={jobStartingDateRef}

                                selected={selectedDate}

                                onChange={handleDateChange}

                                minDate={new Date()}

                                dateFormat="yyyy-MM-dd"

                                className="form-control w-100 dropdown-btn"

                                placeholderText="Select a start date"

                                isClearable

                                wrapperClassName="w-100"

                                showDisabledMonthNavigation

                            />

                        </div>

                    )}



                    {formData.job_starting_date === 'Immediate' && (

                        <div className="alert alert-info mb-3">

                            <strong>Job will start immediate</strong> - No specific start date required

                        </div>

                    )}



                    <div className="timeline-wrapper">

                        <div className="timeline">

                            {["Immediate", "1 week", "1 month", "2 month", "3 month"].map((timeline, index) => {

                                // For display comparison, convert "Immediate" to "Immediate" to match the state

                                const displayTimeline = timeline === 'Immediate' ? 'Immediate' : timeline;



                                return (

                                    <React.Fragment key={timeline}>

                                        <div

                                            className={`timeline-step ${jobStartingTimeline === displayTimeline ? 'active' : ''}`}

                                            onClick={() => handleTimelineSelect(timeline)}

                                        >

                                            <div className={`circle ${jobStartingTimeline === displayTimeline ? '' : 'small'}`}></div>

                                            <span className="label">{timeline}</span>

                                        </div>

                                        {index < 4 && <div className="timeline-line"></div>}

                                    </React.Fragment>

                                );

                            })}

                        </div>

                    </div>

                </div>



                {/* Navigation Buttons */}

                <div className="additional-section mb-4" style={{ marginTop: '20px' }}>

                    <div

                        className="d-flex justify-content-between gap-2"

                        style={{ width: "100%" }}

                    >

                        <Button

                            className="nav-btn"

                            style={{ flex: 1 }}

                            variant="secondary"

                            onClick={() => navigate("/agencydashboard")}

                        >

                            Back

                        </Button>



                        <Button

                            className="nav-btn"

                            style={{ flex: 1 }}

                            variant="primary"

                            onClick={handleNext}

                            disabled={isLoading}

                        >

                            {isLoading ? 'Saving...' : 'Next'}

                        </Button>

                    </div>

                </div>



            </Container>



            {/* Part Time Agreement Modal */}

            <Modal show={showPartTimeModal} onHide={handleCancelPartTime} centered>

                <Modal.Header closeButton>

                    <Modal.Title>Part Time Job Agreement</Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <div className="alert alert-warning">

                        <strong>Important Notice:</strong> You must follow labor laws. Part-time jobs are for permanent residents only

                    </div>

                    <Form.Check

                        type="checkbox"

                        label="I agree to follow all labor laws and regulations for part-time employment"

                        checked={partTimeAgreed}

                        onChange={(e) => setPartTimeAgreed(e.target.checked)}

                        className="mt-3 checkbox-alert d-flex align-items-center"

                    />

                </Modal.Body>

                <Modal.Footer>

                    <Button variant="secondary" onClick={handleCancelPartTime}>

                        Cancel

                    </Button>

                    <Button

                        variant="primary"

                        onClick={handlePartTimeAgreement}

                        disabled={!partTimeAgreed}

                    >

                        I Agree - Select Part Time

                    </Button>

                </Modal.Footer>

            </Modal>

        </>

    );

};



export default AgencyBasicInfo;





